{
  "customer_portal": {
    "reset_request_title": "Resetează parola de client",
    "reset_request_submit": "Trimite instrucțiunile de resetare",
    "reset_password_title": "Alege o parolă nouă de client",
    "reset_password_submit": "Salvează parola nouă",
    "reset_sent": "Dacă există un cont de client eligibil pentru acest email, instrucțiunile de resetare au fost trimise. Verifică inboxul. Linkul expiră în 30 de minute.",
    "reset_help": "Folosește cel puțin 12 caractere. Salvarea unei parole noi închide celelalte sesiuni de client.",
    "forgot_password": "Ai uitat parola de client?",
    "recovery_title": "Solicită un link nou de acces",
    "recovery_help": "Acest link sau sesiunea de configurare nu mai este disponibilă. Verifică din nou emailul pentru a continua sau resetează parola dacă ai deja un cont de client. Orice cerere deja trimisă rămâne salvată.",
    "recovery_verify": "Verifică din nou emailul",
    "verification_title": "Verifică emailul de client",
    "confirmation_title": "Confirmă emailul",
    "password_title": "Creează parola de client",
    "session_title": "Autentificare client",
    "verification_submit": "Trimite emailul de verificare",
    "confirmation_submit": "Verifică emailul",
    "password_submit": "Creează parola",
    "session_submit": "Autentificare",
    "email_address": "Email",
    "password": "Parolă",
    "password_confirmation": "Confirmă parola",
    "help": "Accesul clienților este separat de autentificarea echipei.",
    "password_help": "Emailul este verificat. Creează o parolă de cel puțin 12 caractere pentru istoric. Verificarea se păstrează dacă părăsești această pagină.",
    "sent": "Verifică emailul pentru linkul de confirmare. Linkul expiră în 24 de ore.",
    "history": "Istoricul tău de client",
    "history_help": "Fiecare companie afișează numai istoricul autorizat pentru tine.",
    "empty": "Nicio companie nu ți-a acordat încă acces la istoric.",
    "companies": "Toate companiile",
    "sign_out": "Deconectare",
    "recording": "Înregistrare istorică autorizată",
    "recording_Customer": "Profilul tău de client",
    "invite": "Invită la istoricul de client"
  },
  "product_ux_admin": {
    "tasks": "Activități",
    "review_subscription": "Verifică abonamentul",
    "team": {
      "roster": "Membrii echipei",
      "roster_help": "Verifică accesul activ și invitațiile în așteptare, apoi deschide activitatea pentru o singură persoană.",
      "active_count": "Membri activi: {{count}}",
      "invitations": "Invitații",
      "pending_count": "În așteptare: {{count}}",
      "pending": "În așteptare",
      "expired": "Expirată",
      "invite_impact": "Invitația rămâne în așteptare până când persoana destinatară o acceptă. Rolul și locațiile stabilesc accesul în companie.",
      "roles_unavailable": "Administrarea rolurilor nu este disponibilă în planul actual. Verifică abonamentul înainte de a schimba rolurile.",
      "activation_impact": "Modificările accesului se aplică imediat. Rezolvă responsabilitățile operaționale și de facturare nefinalizate înainte de dezactivare; autorii acțiunilor anterioare se păstrează.",
      "back_roster": "Înapoi la membrii echipei"
    },
    "website": {
      "content_help": "Editează identitatea publică a companiei și conținutul bilingv. Publicarea locațiilor și verificarea domeniului au activități separate.",
      "locations_help": "Alege o singură locație pentru a-i edita descrierea publică și serviciile. Fiecare locație își păstrează limba și moneda.",
      "domain_help": "Urmărește starea proprietății, direcționării și certificatului. Salvarea adresei domeniului nu îl face disponibil.",
      "edit_location": "Editează {{location}}",
      "back_locations": "Înapoi la locațiile publicate",
      "publication": "Publicare",
      "published": "Publicat",
      "unpublished": "Nepublicat",
      "no_locations": "Nu există locații active accesibile care să poată fi publicate.",
      "no_offerings": "Această locație nu are servicii locale disponibile. Configurează serviciile înainte de a le selecta pentru publicare.",
      "review_services": "Verifică serviciile",
      "context": "Site-ul companiei"
    },
    "integrations": {
      "catalogue": "Catalogul integrărilor",
      "details": "Detaliile conexiunii",
      "setup": "Configurare",
      "view": "Deschide {{provider}}",
      "catalogue_help": "Alege un furnizor pentru a verifica cerințele, starea conexiunii și configurarea. Configurarea nu dovedește disponibilitatea trimiterii, plăților sau facturării.",
      "details_help": "Verifică starea observată a conexiunii și cerințele companiei înainte de configurare.",
      "setup_help": "Configurează furnizorul într-o activitate separată. Documentele existente își păstrează furnizorul, iar operațiunile indisponibile cer o acțiune explicită de remediere.",
      "readiness": "Starea conexiunii",
      "provider": "Furnizor",
      "setup_pending": "Configurare în curs",
      "assets": "Resurse conectate: {{count}}",
      "no_assets": "Nu există o resursă autorizată conectată.",
      "unavailable_help": "Configurarea nu este disponibilă în acest mediu. Verifică cerințele furnizorului sau revino la catalog; furnizorul implicit de facturare rămâne neschimbat.",
      "back_catalogue": "Înapoi la catalogul integrărilor",
      "saved_not_ready": "O conexiune salvată trebuie verificată cu succes înainte de a putea fi folosită."
    }
  },
  "product_ux_booking": {
    "setup_return_help": "Ciorna programării este păstrată în această filă. Finalizează configurarea, apoi continuă aceeași programare.",
    "return_to_booking": "Înapoi la programare",
    "proposal_setup_return_help": "Ciorna privată a propunerii este păstrată în această filă. Finalizează configurarea, apoi continuă aceeași propunere.",
    "return_to_proposal": "Înapoi la propunere",
    "services_title": "Adaugă un serviciu disponibil",
    "services_help": "Această locație are nevoie de cel puțin un serviciu disponibil, cu preț și durată, înainte de programare.",
    "bays_title": "Adaugă un post de lucru disponibil",
    "bays_help": "Această locație are nevoie de un post de lucru activ înainte de confirmarea unei programări.",
    "manage_services": "Configurează serviciile",
    "manage_bays": "Configurează un post de lucru",
    "administrator_handoff": "Roagă un administrator să finalizeze configurarea pentru {{location}}. Ciorna programării rămâne în această filă.",
    "administrators": "Administratori: {{names}}",
    "refresh_setup": "Verifică din nou configurarea",
    "unavailable_bay": "Postul de lucru selectat nu mai este disponibil. Alege un post activ după finalizarea configurării.",
    "unavailable_assignee": "Responsabilul selectat nu mai este disponibil. Alege un membru eligibil al echipei.",
    "unavailable_helpers": "Unii colaboratori salvați nu mai sunt disponibili sau sunt acum responsabili de lucrare. Verifică echipa înainte de a continua.",
    "remove_unavailable_helpers": "Elimină colaboratorii indisponibili sau dublați"
  },
  "enquiry_draft": {
    "title": "Solicită servicii de detailing",
    "introduction": "Spune atelierului despre vehicul și lucrările dorite. Verifică detaliile înainte de confirmarea emailului.",
    "private_help": "Poți relua ciorna privată în acest browser timp de cel mult 24 de ore. Verificarea emailului trimite solicitarea acestui atelier; nu confirmă o programare.",
    "idle": "Solicitarea nu a fost încă trimisă.",
    "expired": "Ciorna privată anterioară a expirat. Începe mai jos o solicitare nouă; detaliile ciornei expirate nu sunt afișate.",
    "proof_unavailable": "Această ciornă privată a expirat sau s-a schimbat într-o altă filă. Deschide solicitarea curentă pentru a continua.",
    "open_current": "Deschide solicitarea curentă",
    "saving": "Se salvează ciorna privată…",
    "saved": "Ciorna privată a fost salvată. Solicitarea nu a fost încă trimisă.",
    "failed": "Ultimele modificări nu au putut fi salvate. Păstrează pagina deschisă și reîncearcă; dacă ciorna a expirat, începe o solicitare nouă.",
    "retry": "Reîncearcă salvarea",
    "photos_help": "Fotografiile se încarcă atunci când ceri verificarea emailului. Selectează din nou fotografiile nou alese după redeschiderea sau reîncărcarea paginii.",
    "submitted_help": "Atelierul a primit solicitarea. Intervalul dorit nu reprezintă o programare confirmată. Poți configura separat parola contului de client."
  },
  "product_ux_proposal": {
    "sections": "Secțiunile propunerii",
    "customer": "Client",
    "vehicle": "Vehicul",
    "status": "Stare",
    "services": "Servicii și prețuri",
    "schedule": "Programare și echipă",
    "review_saved": "Verifică schița salvată",
    "review": "Verificare și publicare",
    "delivery": "Trimitere și rezultat",
    "stale": "Contextul propunerii s-a schimbat. Verifică datele curente înainte de a salva modificările.",
    "private_draft": "Schiță privată",
    "continue_schedule": "Continuă la programare și echipă",
    "discard_prompt": "Renunți la modificările nesalvate ale propunerii și revii la cerere?",
    "review_help": "Verifică termenii pe care îi va vedea clientul înainte de publicare. Publicarea creează rezervarea temporară afișată, fără să trimită un mesaj.",
    "published_title": "Propunerea publicată",
    "published_help": "Aceasta este propunerea disponibilă clientului. Trimiterea și decizia clientului sunt pași separați.",
    "private_changes": "Ai o schiță privată mai nouă. Trimiterea folosește ultima propunere publicată până când verifici și publici modificările.",
    "no_publication": "Verifică și publică schița salvată înainte de a alege trimiterea.",
    "delivery_title": "Trimite propunerea publicată",
    "delivery_help": "Alege un canal disponibil, verifică destinatarul și mesajul, apoi confirmă explicit trimiterea. Solicitarea trimiterii nu dovedește primirea mesajului.",
    "email_available": "E-mailul verificat este disponibil pentru previzualizarea mesajului.",
    "email_unavailable": "Trimiterea prin e-mail nu este disponibilă pentru acest client. Folosește linkul prin canalul agreat; nu considera mesajul livrat fără confirmarea rezultatului.",
    "preview_message": "Previzualizează mesajul e-mail",
    "history": "Încercări de trimitere și istoric",
    "manual_title": "Distribuie linkul clientului",
    "manual_help": "Copiază linkul doar către clientul vizat, prin canalul agreat. Copierea sau deschiderea lui nu trimite un mesaj și nu înregistrează livrarea.",
    "current_attempt": "Ultima încercare pentru această propunere publicată",
    "outcome": "Rezultatul deciziei clientului",
    "decision_help": "Decizia ta se aplică exact propunerii afișate mai sus. Dacă propunerea se schimbă, vei verifica noii termeni înainte de confirmare.",
    "accept_once": "Acceptarea confirmă o singură programare după verificarea disponibilității. Nu mai este necesară o acceptare din partea echipei.",
    "reschedule_help": "Programarea curentă rămâne valabilă până când accepți înlocuirea propusă. Refuzul sau propunerea altui interval păstrează programarea inițială.",
    "setup_services": "Adaugă un serviciu local înainte de a compune propunerea",
    "setup_bays": "Adaugă un post de lucru înainte de a propune un interval",
    "setup_help": "Schița privată este păstrată. Configurează elementul lipsă, apoi revino la aceeași cerere fără să introduci din nou datele.",
    "manage_services": "Configurează serviciile și revino",
    "manage_bays": "Adaugă un post de lucru și revino",
    "setup_handoff": "Un administrator al locației {{location}} trebuie să finalizeze configurarea. Schița rămâne disponibilă aici.",
    "recovery_unavailable": "Recuperarea în această filă nu este disponibilă. Păstrează pagina deschisă pentru a nu pierde modificările nesalvate. Dacă este necesară configurarea, deschide-o într-o altă filă, apoi revino aici și alege Verifică din nou configurarea.",
    "setup_new_tab": "Deschide configurarea în altă filă",
    "refresh_setup": "Verifică din nou configurarea",
    "closed_help": "Această cerere are deja o decizie finală a clientului. Verifică rezultatul publicat sau lucrarea confirmată.",
    "open_job": "Deschide lucrarea confirmată",
    "states": {
      "unpublished": "Nepublicată",
      "not_requested": "Nu s-a solicitat trimiterea prin e-mail",
      "queued": "E-mail în așteptarea trimiterii",
      "sending": "Trimitere în curs; rezultatul nu este confirmat",
      "sent": "Trimiterea a fost acceptată de furnizorul de e-mail",
      "failed": "Trimiterea necesită intervenția echipei"
    }
  },
  "resource_drafts": {
    "restored": "Datele nesalvate au fost recuperate din această filă. Verifică-le înainte de salvare.",
    "saved": "Datele nesalvate sunt păstrate în această filă timp de cel mult 24 de ore.",
    "unavailable": "Recuperarea ciornei nu este disponibilă în această filă. Păstrează pagina deschisă până salvezi."
  },
  "resource_workspace": {
    "photos_reload": "Fotografiile alese în acest formular trebuie selectate din nou după reîncărcare.",
    "location": "Locație",
    "customer": "Contextul clientului",
    "vehicle": "Contextul vehiculului",
    "product": "Contextul produsului",
    "service": "Contextul serviciului",
    "current_balance": "Stocul înregistrat în prezent",
    "review_stock": "Verifică stocul curent înainte de a înregistra o recepție, un inventar fizic sau un prag."
  },
  "product_ux_staff": {
    "billing_responsibility": "Responsabilitatea facturării",
    "billing_assignment_needed": "Atribuie facturarea unui membru eligibil al echipei.",
    "billing_help": "Aici se revizuiesc, se aprobă și se confirmă termenii finali. Plata și predarea vehiculului se înregistrează separat.",
    "identity_search": "Caută client, contact, vehicul sau solicitare",
    "identity_search_help": "Caută datele păstrate în solicitare, inclusiv numele clientului, contactul, numărul de înmatriculare sau VIN-ul.",
    "no_matches": "Nicio solicitare nu corespunde filtrelor.",
    "clear_filters": "Șterge filtrele",
    "next_task": "Următoarea sarcină",
    "unavailable_channel": "Răspunde în afara GarageClerk, apoi înregistrează răspunsul mai jos. Această înregistrare nu trimite un mesaj.",
    "collection_pending": "Predarea vehiculului trebuie înregistrată separat de plată.",
    "work_pending": "Lucrarea fizică nu este încă finalizată."
  },
  "product_ux": {
    "workspace": {
      "context": "Contextul lucrării"
    }
  },
  "record_management": {
    "customer_delete_help": "Începe o cerere de ștergere în 30 de zile. Vei verifica cerințele de păstrare și vei confirma numele clientului înainte de orice modificare.",
    "vehicle_management": "Proprietate",
    "job_cancel_confirm": "Confirmă anularea sau neprezentarea",
    "job_cancel_confirm_help": "Această acțiune oprește lucrarea și eliberează postul rezervat. Rezultatul selectat și motivul vor fi păstrate în istoricul lucrării."
  },
  "services": {
    "details_title": "Detalii serviciu",
    "local_title": "Oferta pentru {{location}}",
    "offer_at_location": "Configurează prețul local pentru {{location}}",
    "local_optional_help": "Salvează serviciul comun acum; adaugă ulterior prețul local din Editare.",
    "local_required_help": "Prețul și disponibilitatea locală sunt necesare pentru a reveni la această ciornă.",
    "archive_help": "Arhivează acest serviciu comun în locațiile companiei. Lucrările și istoricul existente se păstrează.",
    "archive_title": "Arhivezi {{service}}?",
    "unconfigured": "Nicio ofertă locală configurată",
    "title": "Servicii",
    "add": "Adaugă serviciu",
    "edit": "Editează serviciul",
    "name": "Numele serviciului",
    "description": "Descriere",
    "save": "Salvează serviciul",
    "configure": "Configurează oferta",
    "save_offering": "Salvează oferta",
    "archive": "Arhivează serviciul",
    "archived": "Arhivat",
    "available": "Disponibil în această locație",
    "unavailable": "Indisponibil în această locație",
    "empty": "Compania nu are încă servicii.",
    "shared_help": "Numele și descrierile serviciilor sunt comune companiei. Liniile reprezentate anterior păstrează conținutul original.",
    "local_help": "Disponibilitatea, prețurile, durata și taxa configurată de mai jos se aplică locației {{location}}.",
    "archived_help": "Acest serviciu este arhivat și nu poate fi selectat pentru lucrări noi.",
    "unit_price": "Preț unitar",
    "currency": "Codul monedei",
    "estimated_minutes": "Durata estimată (minute)",
    "tax_rate": "Cota taxei configurate (%)",
    "tax_label": "Denumirea taxei",
    "tax_mode": "Prezentarea taxei",
    "inclusive": "Taxă inclusă",
    "exclusive": "Taxă adăugată",
    "amount_help": "Monede acceptate: RON, USD, EUR și GBP. Introdu prețuri cu maximum două zecimale și procente ale taxei cu maximum patru. Folosește virgulă sau punct pentru zecimale, fără separatori de mii. Taxa este configurată explicit.",
    "price": "{{amount}} {{currency}}",
    "duration_one": "{{count}} minut",
    "duration_few": "{{count}} minute",
    "duration_other": "{{count}} de minute"
  },
  "team": {
    "save_member": "Salvează membrul",
    "admin_access_help": "Administratorii au acces la toate locațiile active. Alege alt rol pentru a stabili accesul la fiecare locație.",
    "admin_history_help": "Administratorii pot consulta istoricul tuturor locațiilor retrase. După schimbarea rolului, se păstrează doar accesul istoric atribuit explicit.",
    "deactivate_confirmation": "Dezactivezi membrul echipei?",
    "deactivate_confirmation_help": "Această acțiune elimină accesul persoanei la această companie. Istoricul activității și apartenența la alte companii se păstrează. Rezolvă lucrările neterminate înainte de dezactivare.",
    "invite_title": "Invită un membru al echipei",
    "invite_description": "Alege un rol și cel puțin o locație.",
    "email": "E-mail",
    "role": "Rol",
    "admin": "Administrator",
    "manager": "Manager",
    "member": "Membru",
    "inactive": "Inactiv",
    "send_invitation": "Trimite invitația",
    "save_role": "Salvează rolul",
    "active_access": "Locații active · acces operațional",
    "retired_history_access": "Locații inactive · acces doar la istoric",
    "retired_history_help": "Permisiunile existente pentru istoric se păstrează când modifici accesul activ. Debifează o locație inactivă și salvează accesul pentru a revoca istoricul și rapoartele sale. Administratorii păstrează istoricul întregii companii. Locația nu se reactivează.",
    "save_access": "Salvează accesul",
    "reactivate": "Reactivează",
    "deactivate": "Dezactivează",
    "pending_invitations": "Invitații în așteptare"
  },
  "activation": {
    "title": "Finalizează configurarea",
    "description": "Spațiul de lucru este salvat. Finalizează plata securizată pentru a începe să folosești GarageClerk.",
    "saved_title": "Spațiu de lucru salvat",
    "trial_title": "Perioada ta de probă",
    "subscription_title": "Abonamentul tău",
    "ready": "Continuă la plata securizată pentru a activa spațiul de lucru. Datele salvate se păstrează dacă trebuie să revii.",
    "failed": "Plata securizată nu a putut fi deschisă. Datele spațiului de lucru sunt salvate. Încearcă din nou pentru a continua configurarea.",
    "cancelled": "Plata nu a fost finalizată. Datele spațiului de lucru sunt salvate. Continuă când ești pregătit.",
    "incomplete": "Abonamentul nu a fost confirmat. Continuă cu abonamentul existent pentru a finaliza activarea.",
    "unavailable": "Plata securizată nu este disponibilă momentan. Datele spațiului de lucru sunt salvate. Încearcă din nou mai târziu.",
    "recover": "Finalizează configurarea abonamentului",
    "paid_terms": "{{post_plan}} costă {{amount}} pe {{interval}}. Plata securizată nu va începe o nouă perioadă de probă."
  },
  "access": {
    "configure_provider": "Configurează {{provider}}",
    "show_password": "Arată parola",
    "hide_password": "Ascunde parola",
    "close_notice": "Închide notificarea",
    "setup_steps": "Progresul configurării",
    "business": "Companie",
    "location": "Locație",
    "hours_review": "Program și verificare",
    "review_setup": "Verifică datele configurării",
    "checkout_help": "Datele se salvează înainte de plata securizată. Dacă plata este întreruptă, continuă din Finalizează configurarea.",
    "setup_help": "Configurează compania, locația și programul. Poți reveni la detalii înainte de a începe perioada de probă.",
    "invoices_unavailable": "Istoricul facturilor nu este disponibil momentan. Încearcă din nou mai târziu.",
    "edit_member": "Editează accesul",
    "member_impact": "Verifică rolul și accesul la locații înainte de salvare. Lucrările existente pot necesita o predare explicită.",
    "team_limit": "Planul curent nu are locuri disponibile în echipă. Gestionează resursele active sau verifică planul înainte de a invita.",
    "website_content": "Conținut",
    "website_locations": "Locații",
    "website_domain": "Domeniu",
    "review_changes": "Verifică modificările",
    "resource_review": "Verifică resursele păstrate și predările",
    "resource_impact": "Doar personalul și locațiile selectate rămân active. Predările explicite sunt verificate din nou la confirmare. Istoricul lucrărilor rămâne disponibil conform regulilor de acces existente.",
    "retained_count": "{{staff}} membri · {{locations}} locații păstrate",
    "no_change_yet": "Nicio modificare nu a fost salvată încă.",
    "pending_decision": "Este necesară decizia ta",
    "set_password_later": "Setează parola mai târziu",
    "optional_password": "Solicitarea este deja trimisă. Parola este opțională și îți permite să revii la istoricul de client.",
    "contact_vehicle": "Contact și vehicul",
    "service_time": "Serviciu și interval dorit",
    "review_verify": "Verificare și confirmare email",
    "enquiry_review_help": "Verifică detaliile, apoi salvează ciorna privată și confirmă emailul pentru a trimite solicitarea. Aceasta nu rezervă un interval și nu creează o plată.",
    "provider_help": "Alege un furnizor, finalizează configurarea și verifică starea înainte de utilizare."
  },
  "workflow": {
    "customer": "Client",
    "vehicle": "Vehicul",
    "stock_changed": "Stocul s-a schimbat. Verifică soldul curent înainte de a păstra numărătoarea măsurată.",
    "review_context": "Verifică contextul curent și păstrează modificările",
    "review_context_help": "Verifică identitatea, starea și soldul curent al lucrării de mai sus. Continuarea păstrează serviciile și datele de facturare introduse.",
    "estimate_unavailable": "Alege servicii disponibile în aceeași monedă pentru a vedea estimarea.",
    "no_services": "Toate serviciile potrivite sunt deja selectate sau niciun serviciu nu corespunde căutării.",
    "add_service": "Adaugă serviciu",
    "choose_services": "Alege doar lucrările incluse. Serviciile suplimentare rămân în acest selector.",
    "add": "Adaugă",
    "remove": "Elimină",
    "line_discount": "Ajustează reducerea liniei",
    "discount_none": "Fără reducere",
    "discount_amount": "Sumă fixă",
    "discount_percentage": "Procent",
    "estimate": "Total estimat",
    "estimate_help": "Estimare de lucru. Salvează și previzualizează taxele, rotunjirea și termenii exacți înainte de publicare.",
    "changed_service": "Termenii din catalog s-au schimbat. Verifică termenii curenți; prețul și cantitatea introduse sunt păstrate.",
    "unavailable_service": "Acest serviciu nu mai este disponibil. Elimină-l înainte de a continua.",
    "review_service": "Acceptă termenii curenți din catalog",
    "request_navigation": "Secțiunile solicitării",
    "conversation": "Conversație",
    "details": "Detalii",
    "activity": "Activitate",
    "no_messages": "Nu sunt disponibile mesaje importate.",
    "stock_return_help": "Înregistrează recepția reală sau inventarul fizic, apoi revino la consumul măsurat neschimbat.",
    "review_stock": "Verifică stocul curent și păstrează această numărătoare",
    "stock_products": "Produse în această locație",
    "stock_empty": "Stoc epuizat",
    "stock_low": "Stoc redus",
    "search_products": "Caută produse",
    "document_details": "Vezi detaliile documentului",
    "document_help": "Emiterea, livrarea, raportarea și alocarea încasărilor sunt fapte independente.",
    "decline_review": "Refuzarea acestor termeni nu anulează lucrarea și nu mută bani. Confirmă decizia mai jos.",
    "offline_approval": "Înregistrează aprobarea clientului",
    "billing_history": "Istoricul verificării",
    "current_terms": "Termeni curenți"
  },
  "customer_deletions": {
    "title": "Șterge clientul",
    "start": "Începe ștergerea în 30 de zile",
    "queue": "Ștergeri de clienți",
    "restore": "Restaurează clientul",
    "empty": "Nu există ștergeri de clienți.",
    "explanation": "Clientul și datele operaționale dependente sunt ascunse imediat. Administratorii pot restaura grupul înainte de termenul de 30 de zile. Apoi datele operaționale sunt eliminate definitiv.",
    "resolve": "Rezolvă explicit lucrările active sau viitoare, propunerile și soldurile. Ștergerea nu anulează lucrări și nu mută bani.",
    "confirm": "Tastează {{name}} pentru confirmare",
    "basis": "Temeiul final aplicabil și cerințele suplimentare de păstrare",
    "deadline": "Data ștergerii arhivei financiare (UTC)",
    "policy": "Obligatoriu dacă există dovezi fiscale sau de plată. Introdu termenul final aplicabil și temeiul factual/legal după verificarea tuturor cerințelor relevante. Ștergerea începe la 00:00 UTC la începutul acestei date exclusive. Dovezile necesare sunt criptate separat; profilurile, fotografiile și istoricul complet al lucrărilor sunt eliminate.",
    "due": "Termenul eliminării operaționale",
    "states": {
      "pending": "Ștergere în așteptare",
      "restored": "Restaurat",
      "purged": "Date operaționale eliminate"
    },
    "archive": "Vezi dovezile financiare necesare",
    "rule": "Ajutor pentru termenul de păstrare (opțional)",
    "rules": {
      "custom": "Termen aplicabil stabilit separat",
      "ro_accounting": "România — documente contabile",
      "us_ordinary": "Impozit federal SUA — reper obișnuit de 3 ani",
      "us_omission": "Impozit federal SUA — venit omis peste 25%, reper de 6 ani"
    },
    "rule_help": "Folosește date reale ale afacerii; data emiterii facturii nu stabilește aceste termene. Pentru alte reguli sau excepții, folosește termenul stabilit separat.",
    "year_end": "Data reală de încheiere a exercițiului financiar",
    "ro_help": "Documentele contabile: cinci ani de la 1 iulie după încheierea exercițiului financiar. Acesta poate diferi de anul calendaristic. Verifică cerințele suplimentare aplicabile.",
    "ro_source": "Legea contabilității, articolele 25 și 27",
    "filed": "Data reală a depunerii declarației fiscale",
    "return_due": "Termenul legal inițial al declarației (fără prelungiri de depunere)",
    "exception": "Situații de excepție în SUA",
    "exceptions": {
      "unknown": "Nestabilite",
      "none": "Nu se aplică un caz special sau o obligație nerezolvată",
      "special": "Caz special sau obligație — folosește un termen separat"
    },
    "us_help": "Acesta este un reper federal, nu o dată sigură de ștergere UTC. Declarațiile nedepuse/frauduloase, proprietățile, cererile de rambursare/reportare, creanțele nerecuperabile și controalele/obligațiile active necesită analiză separată. Regulile statale/locale, zilele complete și fusul orar, weekendurile/sărbătorile și prelungirile de control pot impune un termen ulterior. Cazurile necunoscute sau speciale nu primesc un rezultat finit automat.",
    "us_source": "Ghidul IRS pentru păstrarea documentelor",
    "us_timing_source": "Regulile IRS pentru depunere și termene",
    "us_reference": "Data de referință federală: {{date}}. Introdu separat data finală aplicabilă de ștergere UTC și temeiul; termenul real poate fi ulterior.",
    "ro_reference": "Reper contabil minim: {{date}}. Introdu data finală aplicabilă de ștergere UTC și temeiul, inclusiv cerințele suplimentare."
  },
  "workspace": {
    "navigation": "Secțiunile lucrării",
    "balance": "Sold de încasat",
    "review_billing": "Verifică facturarea",
    "action_help": "Confirmă acțiunea pentru versiunea curentă a lucrării.",
    "complete_help": "Finalizarea lucrării eliberează boxa. Plata și predarea rămân înregistrări separate.",
    "back_parent": "Înapoi la înregistrare",
    "assign": "Atribuie echipa",
    "assignment_help": "Actualizează responsabilitatea operațională. Echipa acceptată și responsabilitatea de facturare rămân înregistrate separat.",
    "assignment_pending": "Închide sau soluționează reprogramarea în așteptare înainte de a schimba echipa.",
    "no_activity": "Nu există activitate înregistrată.",
    "assigned": "Echipă reatribuită",
    "reordered": "Poziție schimbată pe panou",
    "system": "Acțiune de sistem sau a clientului",
    "tabs": {
      "overview": "Prezentare",
      "schedule": "Programare și echipă",
      "billing": "Facturare",
      "payments": "Plăți",
      "documents": "Documente",
      "products": "Produse",
      "activity": "Activitate"
    },
    "events": {
      "created": "Creat",
      "updated": "Actualizat",
      "job_board_ordered": "Poziție schimbată pe panou"
    },
    "kinds": {
      "Job": "Lucrare",
      "BillingReview": "Revizuire de facturare",
      "JobReschedule": "Reprogramare",
      "PaymentPosting": "Înregistrare de plată",
      "AdvanceRequest": "Cerere de avans",
      "FiscalDocument": "Document fiscal",
      "ProductConsumption": "Consum de produs"
    }
  },
  "home_attention": {
    "today": "Lucrările de astăzi",
    "view_schedule": "Vezi programul",
    "today_empty": "Nu există lucrări programate sau în curs pentru astăzi.",
    "today_more": "Sunt afișate primele 8 din {{count}} lucrări. Deschide programul pentru restul activității.",
    "title": "Necesită atenție",
    "help": "Activitatea curentă a acestei locații. Deschide o listă pentru a verifica înregistrările.",
    "requests": "Solicitări noi",
    "overdue": "Avansuri restante",
    "stock": "Produse la prag sau sub prag",
    "setup": "Pregătește locația",
    "setup_help": "Adaugă elementele necesare pentru programări. Linkurile deschid setările locației curente.",
    "ask_admin": "Cere unui administrator să adauge o boxă activă și un serviciu local disponibil înainte de programare.",
    "add_bay": "Adaugă o boxă activă",
    "add_service": "Adaugă un serviciu local disponibil",
    "filtered": "Etapă: {{stage}}"
  },
  "board_interactions": {
    "destination_position": "Poziția {{position}} în {{stage}}.",
    "start": "La începutul etapei",
    "end": "La sfârșitul etapei",
    "drag": "Mută lucrarea pentru {{name}}",
    "move": "Mută lucrarea",
    "help": "Trage o fișă pentru a o muta sau atinge fundalul ei pentru opțiuni de plasare. Finalizarea necesită lucru încheiat, plată și predare.",
    "instructions": "Apasă Spațiu sau Enter pentru a selecta lucrarea. Folosește Sus și Jos pentru ordonare, Stânga și Dreapta pentru o etapă permisă. Apasă Spațiu sau Enter pentru plasare ori Escape pentru anulare. Tab încheie și el mutarea. Apasă Shift+F10 pentru opțiuni de plasare fără tragere.",
    "picked": "Lucrare selectată pentru {{name}}.",
    "destination": "Destinație: {{stage}}.",
    "no_target": "Nu există o destinație permisă.",
    "dropped": "Plasare selectată. Opțiunile necesare trebuie confirmate înainte de salvare.",
    "cancelled": "Mutare anulată. Poziția inițială este păstrată.",
    "saved": "Mutarea lucrării a fost salvată.",
    "restored": "Mutarea nu a fost salvată. Ordinea curentă a serverului a fost restaurată.",
    "page": "Pagina {{page}} din {{pages}}",
    "menu_help": "Alege etapa și poziția față de o lucrare din pagina afișată. Paginile celorlalte coloane sunt păstrate.",
    "stage": "Etapa de destinație",
    "position": "Poziție",
    "before": "Înainte de",
    "after": "După",
    "neighbor": "Lucrare vecină",
    "confirm": "Mută în {{stage}}",
    "confirm_help": "Lucrarea rămâne pe poziția curentă până la confirmare. Anularea nu modifică nimic.",
    "save_move": "Confirmă mutarea",
    "continue": "Continuă",
    "card": "Fișă de lucrare"
  },
  "calendar_views": {
    "period": {
      "past": "Interval programat trecut",
      "current": "Interval programat curent",
      "future": "Interval programat viitor"
    },
    "show_day": "Arată ziua",
    "show_week": "Arată săptămâna",
    "show_agenda": "Arată agenda",
    "notes": "Detalii de programare și comenzi de tastatură",
    "slot": "Creează programare: {{bay}}, {{date}}, {{time}}. Disponibilitatea se verifică la salvare.",
    "slot_keys": "Într-o celulă fără înregistrare, folosește Sus/Jos sau Home/End pentru alegerea orei, apoi Enter pentru programare.",
    "views": "Vizualizări ale programului",
    "day": "Zi",
    "week": "Săptămână",
    "agenda": "Agendă",
    "day_date": "Data",
    "partial": "Aceasta este o pagină dintr-un program aglomerat. Alte pagini pot conține rezervări; o zonă goală nu confirmă disponibilitatea.",
    "capacity_help": "Orele folosesc fusul locației. Ocuparea în curs poate depăși sfârșitul planificat. Disponibilitatea se verifică la salvare.",
    "timeline": "Cronologia boxelor",
    "bay_timeline": "Cronologie săptămânală pentru {{bay}}",
    "create_slot": "Creează programare",
    "no_entries": "Nu există înregistrări pe această pagină pentru ziua aleasă."
  },
  "staff_ux": {
    "estimate_help": "Estimare pe baza serviciilor selectate. Taxele și rotunjirile finale sunt calculate când confirmi lucrarea.",
    "booking_steps": "Pașii programării",
    "step_count": "Pasul {{current}} din {{total}}",
    "back": "Înapoi",
    "continue": "Continuă",
    "review_help": "Confirmă detaliile pentru a crea lucrarea. Disponibilitatea și condițiile serviciilor sunt verificate din nou la salvare.",
    "steps": {
      "customer": "Client",
      "vehicle": "Vehicul",
      "services": "Servicii",
      "schedule": "Program și echipă",
      "review": "Verificare"
    },
    "step_titles": {
      "customer": "Alege un client",
      "vehicle": "Alege un vehicul",
      "services": "Alege serviciile",
      "schedule": "Program și echipă",
      "review": "Verifică programarea"
    },
    "location_details_help": "Numele și adresa acestei locații fizice.",
    "location_regional_help": "Limba, moneda și fusul orar pentru activitatea acestei locații.",
    "location_booking_help": "Stabilește cât timp rămâne rezervat intervalul propus unui client."
  },
  "navigation": {
    "new_job": "Lucrare nouă",
    "dashboard": "Panou de control",
    "calendar": "Calendar",
    "job_board": "Tabla lucrărilor",
    "location_settings": "Setările locației",
    "regional": "Preferințe regionale",
    "opening_hours": "Program de lucru",
    "booking_rules": "Reguli de programare",
    "switch_location": "Schimbă locația",
    "user_menu": "Meniul utilizatorului",
    "home": "Acasă",
    "schedule": "Program",
    "subscription": "Abonament",
    "board": "Panou",
    "list": "Listă",
    "daily": "Activitate zilnică",
    "jobs_views": "Vizualizări lucrări",
    "location_details": "Detalii locație",
    "settings_sections": "Secțiuni setări",
    "danger": "Acțiuni ireversibile",
    "close": "Închide navigarea",
    "skip": "Sari la conținutul principal",
    "back_to_collection": "Înapoi la rezultate",
    "recovery": "Recuperare acces",
    "groups": {
      "personal": "Personal",
      "company": "Companie",
      "location": "Locație",
      "history": "Istoric"
    }
  },
  "whatsapp": {
    "enquiry": "Solicitare WhatsApp",
    "description": "Conectează contul WhatsApp Business și numărul Cloud API înregistrat, deținute de companie, prin Meta Embedded Signup.",
    "constraints": "Sunt necesare accesul aplicației Meta, verificarea companiei și înregistrarea numărului. Mesajul clientului deschide o fereastră de 24 de ore, fără consimțământ pentru inițierea mesajelor. Mesajele inițiate de companie cer consimțământ și șabloane aprobate. Trimiterea și aprobarea șabloanelor nu sunt disponibile aici.",
    "guide": "Ghid Meta Embedded Signup",
    "unavailable": "Autorizarea sau disponibilitatea WhatsApp necesită atenție. Verifică aplicația Meta, permisiunile, proprietatea companiei și numărul Cloud API înregistrat. Poate fi necesară aprobarea umană sau Meta.",
    "default_location": "Locația implicită de preluare",
    "authorize": "Începe autorizarea WhatsApp",
    "continue": "Continuă cu Meta",
    "company_owned": "Confirm că acest cont de business și numărul aparțin companiei și sunt autorizat să le conectez.",
    "choose_number": "Alege un număr autorizat",
    "intake_at": "Cererile noi sosesc la {{location}}.",
    "no_numbers": "Nu a fost returnat un număr Cloud API înregistrat eligibil. Finalizează verificarea și înregistrarea companiei/numărului la Meta, apoi autorizează din nou.",
    "number": "Număr de business",
    "connect": "Conectează numărul ales",
    "disconnect": "Deconectează WhatsApp",
    "save_location": "Salvează locația de preluare",
    "checked": "Ultima verificare: {{date}}",
    "environment": {
      "test": "Conexiuni WhatsApp de test",
      "live": "Conexiuni WhatsApp de producție"
    },
    "states": {
      "ready": "Conectată și verificată ultima dată",
      "pending": "Verificarea abonării este în așteptare",
      "disconnected": "Deconectată",
      "unavailable": "Autorizarea necesită atenție. Autorizează numărul din nou."
    },
    "messages": "Mesaje WhatsApp",
    "attachments": "{{count}} atașament(e) primite. Deschide inboxul WhatsApp pentru a vedea fișierele originale.",
    "window": "Fereastra de servicii pentru client se încheie la {{time}}. Acest moment nu acordă consimțământ sau permisiune de trimitere.",
    "outbound_unavailable": "Trimiterea nu este disponibilă. Mesajele inițiate de companie cer consimțământ și un șablon aprobat; disponibilitatea șabloanelor nu a fost verificată. Înregistrează un răspuns gestionat extern folosind acțiunea existentă de răspuns.",
    "connected": "Numărul WhatsApp a fost conectat și verificat ultima dată.",
    "location_saved": "Locația implicită a fost salvată. Cererile existente își păstrează locația.",
    "disconnected": "WhatsApp a fost deconectat. Istoricul cererilor rămâne disponibil."
  },
  "instagram": {
    "enquiry": "Solicitare Instagram",
    "description": "Conectează un cont Business sau Creator prin Instagram Login și alege unde sosesc cererile noi. Nu este necesară o pagină Facebook.",
    "constraints": "Clientul trebuie să inițieze conversația și sunt necesare permisiunile Meta. Tokenurile expiră sau pot fi revocate. Răspunsurile obișnuite sunt limitate la 24 de ore. Accesul în producție și mesageria extinsă necesită aprobarea separată Meta.",
    "guide": "Ghid Meta pentru Instagram Login",
    "unavailable": "Configurarea Instagram nu este disponibilă. Cere administratorului platformei să finalizeze configurarea aplicației și a adreselor de retur.",
    "default_location": "Locația implicită de preluare",
    "authorize": "Autorizează contul Instagram",
    "choose_account": "Alege un cont autorizat",
    "intake_at": "Cererile noi sosesc la {{location}}.",
    "no_accounts": "Nu a fost returnat un cont profesional eligibil. Verifică tipul contului și permisiunile Instagram solicitate, apoi autorizează din nou.",
    "account": "Contul Instagram",
    "connect": "Conectează contul ales",
    "disconnect": "Deconectează contul",
    "save_location": "Salvează locația de preluare",
    "checked": "Ultima verificare: {{date}}",
    "environment": {
      "test": "Conexiuni Instagram de test",
      "live": "Conexiuni Instagram de producție"
    },
    "states": {
      "ready": "Conectată și verificată ultima dată",
      "pending": "Verificarea abonării este în așteptare",
      "disconnected": "Deconectată",
      "unavailable": "Autorizarea necesită atenție. Autorizează contul din nou."
    },
    "messages": "Mesaje Instagram",
    "attachments": "{{count}} atașament(e) primite. Deschide inboxul Instagram pentru a vedea fișierele originale.",
    "window": "Fereastra obișnuită de mesagerie se încheie la {{time}}. Acest moment nu autorizează trimiterea.",
    "outbound_unavailable": "Trimiterea prin GarageClerk nu este disponibilă până la activarea mesageriei operaționale acceptate. Înregistrează orice răspuns trimis din inboxul Instagram folosind acțiunea existentă de răspuns.",
    "connected": "Contul Instagram a fost conectat și verificat.",
    "location_saved": "Locația implicită a fost salvată. Cererile existente își păstrează locația.",
    "disconnected": "Contul Instagram a fost deconectat. Istoricul cererilor rămâne disponibil."
  },
  "facebook": {
    "description": "Conectează paginile administrate de companie și alege unde sosesc cererile noi.",
    "constraints": "Sunt necesare permisiunile Meta, evaluarea aplicației și autorizarea paginii. Tokenurile pot expira sau pot fi revocate. Răspunsurile obișnuite sunt limitate la 24 de ore; alte tipuri de mesaje necesită aprobarea separată a furnizorului.",
    "guide": "Ghid Meta pentru configurarea Messenger",
    "unavailable": "Configurarea Facebook nu este disponibilă. Cere administratorului platformei să finalizeze configurarea aplicației și a adreselor de retur.",
    "default_location": "Locația implicită de preluare",
    "authorize": "Autorizează paginile Facebook",
    "choose_page": "Alege o pagină autorizată",
    "intake_at": "Cererile noi sosesc la {{location}}.",
    "no_pages": "Nu au fost returnate pagini eligibile. Verifică rolurile paginii și permisiunile solicitate în Meta, apoi autorizează din nou.",
    "page": "Pagina Facebook",
    "connect": "Conectează pagina aleasă",
    "disconnect": "Deconectează pagina",
    "save_location": "Salvează locația de preluare",
    "checked": "Ultima verificare: {{date}}",
    "environment": {
      "test": "Conexiuni Messenger de test",
      "live": "Conexiuni Messenger de producție"
    },
    "states": {
      "ready": "Conectată și verificată ultima dată",
      "pending": "Verificarea abonării este în așteptare",
      "disconnected": "Deconectată",
      "unavailable": "Autorizarea necesită atenție. Autorizează pagina din nou."
    },
    "messages": "Mesaje Messenger",
    "attachments": "{{count}} atașament(e) primite. Deschide inboxul paginii pentru a vedea fișierele originale.",
    "window": "Fereastra obișnuită de mesagerie se încheie la {{time}}. Acest moment nu autorizează trimiterea.",
    "outbound_unavailable": "Trimiterea prin GarageClerk nu este disponibilă până la activarea mesageriei operaționale acceptate. Înregistrează orice răspuns trimis din inboxul paginii folosind acțiunea existentă de răspuns.",
    "connected": "Pagina Facebook a fost conectată și verificată.",
    "location_saved": "Locația implicită a fost salvată. Cererile existente își păstrează locația.",
    "disconnected": "Pagina Facebook a fost deconectată. Istoricul cererilor rămâne disponibil."
  },
  "fiscal_documents": {
    "refresh": "Actualizează din verificarea confirmată",
    "refresh_confirm": "Înlocuiește sumele ciornei neemise cu verificarea confirmată curentă și șterge dovezile de conversie.",
    "review_changed": "Verificarea finală s-a schimbat. Actualizează ciorna și verifică datele fiscale înainte de emitere.",
    "credited_minor": "Documente de credit emise",
    "credit_balance_minor": "Fonduri încasate peste soldul fiscal",
    "allocation_history": "Alocări recente ale încasărilor",
    "connection_pending": "Conexiunea la furnizor este în așteptare",
    "title": "Documente fiscale",
    "prepare": "Pregătește ciorna fiscală",
    "save": "Salvează ciorna fiscală",
    "edit": "Editează datele de facturare",
    "draft_help": "Salvează datele de facturare pentru verificarea finală confirmată. Ciorna nu are număr fiscal și nu a fost emisă sau trimisă.",
    "provider_context": "Contextul furnizorului ales",
    "context_help": "Folosește contul real al comerciantului și referințele explicite pentru document și raportare. Nu se aleg automat serii, numere, reguli fiscale sau alt furnizor.",
    "independent_help": "Emiterea, livrarea către client, raportarea fiscală, alocarea plăților și ridicarea vehiculului sunt fapte separate.",
    "review_required": "Confirmă verificarea finală cu un responsabil de facturare eligibil înainte de pregătirea facturii.",
    "empty": "Nu există documente fiscale.",
    "unavailable": "Emiterea necesită o conexiune verificată la furnizor. Pregătirea ciornei nu conectează un furnizor și nu efectuează raportarea fiscală.",
    "confirm": "Am verificat datele fiscale și contextul furnizorului ales.",
    "request": "Solicită emiterea sau reconcilierea",
    "provider": "Furnizor de facturare",
    "provider_account": "Contul comerciantului la furnizor",
    "environment": "Mediu",
    "document_context": "Referința setărilor documentului",
    "reporting_context": "Referința setărilor de raportare",
    "stripe": "Stripe",
    "smartbill": "SmartBill",
    "easybill_ro": "EasyBill.ro",
    "test": "Test",
    "live": "Producție",
    "issuer": "Emitent legal",
    "customer": "Clientul facturii",
    "fiscal": "Dovezi fiscale suplimentare",
    "tax_help": "Taxele și reducerile explicite provin din verificarea confirmată. Completează dovezile de conversie și raportare doar când contextul verificat le cere. Taxele din SUA rămân configurate de comerciant; determinarea automată este amânată.",
    "name": "Denumire legală",
    "country": "Țară",
    "address": "Adresă de facturare",
    "city": "Localitate",
    "region": "Județ / stat",
    "postal_code": "Cod poștal",
    "tax_identifier": "Identificator fiscal",
    "email": "Email de facturare",
    "vat_ron": "Sumă TVA (RON)",
    "vat_ron_minor": "Sumă TVA (RON)",
    "fx_reference": "Referința dovezii de conversie",
    "tax_setup_reference": "Referința setărilor fiscale ale comerciantului",
    "invoice": "Factură",
    "credit_note": "Notă de credit integrală",
    "draft": "Ciornă — neemisă",
    "requested": "Emiterea a fost solicitată",
    "uncertain": "Rezultat incert — reconciliere necesară",
    "rejected": "Furnizorul a confirmat neemiterea",
    "issued": "Emis",
    "net_minor": "Net",
    "tax_minor": "Taxă",
    "item_discount_minor": "Reduceri servicii",
    "job_discount_minor": "Reducerea lucrării",
    "total_minor": "Total brut",
    "advance_minor": "Avansuri păstrate la emitere",
    "amount_due_minor": "Datorat după avansurile reprezentate",
    "allocated_minor": "Fonduri nete alocate în prezent",
    "outstanding_minor": "Sold nealocat al documentului",
    "delivery": "Livrare către client",
    "reporting": "Raportare fiscală",
    "not_requested": "Nesolicitat",
    "not_required": "Nu este necesar în contextul ales",
    "pending": "În așteptare",
    "delivered": "Livrat",
    "failed": "Eșuat",
    "accepted": "Acceptat",
    "rejected_status": "Respins",
    "inclusive": "Taxă inclusă",
    "exclusive": "Taxă adăugată",
    "allocate": "Alocă încasarea existentă",
    "allocation_help": "Aplică acestui document bani deja înregistrați. Nu încasează fonduri și nu modifică soldul lucrării.",
    "receipt": "Încasare înregistrată"
  },
  "resources": {
    "title": "Resurse active și predări",
    "description": "Alege personalul și locațiile păstrate. Dezactivarea este imediată și păstrează istoricul autorizat.",
    "paused": "Operațiunile sunt oprite până când resursele respectă planul actual.",
    "resolve_or_upgrade": "Păstrează locațiile cu angajamente nerezolvate. Rezolvă lucrările deschise înainte de dezactivare. Dacă planul actual nu le poate păstra, treci la un plan superior din Facturare pentru a relua lucrul.",
    "plan": "Aplică aceste limite de resurse",
    "limits": "{{staff}} angajați · {{locations}} locații",
    "unlimited": "Nelimitat",
    "no_subscription_change": "Salvează imediat alegerile de resurse. Nu modifică abonamentul și nu încasează bani.",
    "staff": "Personal păstrat",
    "staff_help": "Păstrează propriul acces de administrator. Debifează personalul doar după alegerea explicită a înlocuitorilor eligibili pentru operațiunile și facturarea lucrărilor neterminate.",
    "locations": "Locații păstrate",
    "locations_help": "Cererile, propunerile, programările, lucrările și soldurile clienților trebuie rezolvate înainte de dezactivarea unei locații. Angajamentele nu sunt mutate sau anulate aici.",
    "unresolved": "Angajamente nerezolvate",
    "handoffs": "Predarea lucrărilor neterminate",
    "handoffs_help": "Pentru fiecare lucrare afectată, alege întreaga echipă operațională actuală și înlocuitorul de facturare dacă există unul. Păstrează acel personal. Rezolvă mai întâi ofertele de reprogramare în așteptare. Prețurile acceptate, programarea și autorii originali se păstrează.",
    "review_notice": "După predare, pregătește din nou verificările de facturare în așteptare pornind de la lucrarea actuală. Sumele confirmate și istoricul aprobărilor clienților se păstrează.",
    "current_assignment": "Responsabil actual: {{name}}",
    "operational_replacement": "Înlocuitor operațional",
    "billing_replacement": "Înlocuitor pentru facturare (administrator sau manager)",
    "choose": "Alege explicit",
    "helpers": "Ajutoare păstrate (opțional)",
    "save": "Salvează resursele păstrate și predările",
    "retained_history": "Istoricul locațiilor păstrat",
    "history_help": "Vizitele reprezentate și soldurile reale rămân disponibile doar în citire personalului activ autorizat. Istoricul clienților păstrează regulile originale de acces.",
    "inactive": "Inactiv",
    "reactivate": "Reactivează {{name}}",
    "no_jobs": "Nu există lucrări înregistrate la această locație.",
    "balance": "Total: {{total}} · Încasat: {{received}} · Restant: {{outstanding}}"
  },
  "vehicle_reports": {
    "title": "Istoric de servicii pentru vehicul",
    "scope": "Condițiile acceptate ale lucrărilor la programarea reprezentată, în ordine cronologică. Prețurile afișate sunt sumele acceptate cu taxe, după reduceri. Modificările ulterioare de facturare sunt separate. Acest raport de servicii nu este o factură.",
    "customer": "Client / proprietar înregistrat",
    "date": "Vizită reprezentată",
    "currency": "Monedă convenită",
    "reference": "Referință lucrare",
    "services": "Servicii reprezentate",
    "line_total": "Total acceptat al serviciului",
    "item_discount_minor": "Reduceri servicii",
    "job_discount_minor": "Reducere lucrare",
    "net_minor": "Valoare netă",
    "tax_minor": "Taxă",
    "total_minor": "Total acceptat al lucrării",
    "prices_excluded": "Prețurile serviciilor sunt excluse",
    "photo_scope": "Fotografie păstrată la această locație pentru versiunea vehiculului și clientul înregistrat al lucrării.",
    "include_prices": "Include prețurile acceptate ale serviciilor",
    "include_photos": "Include fotografiile istorice ale vehiculului",
    "select": "Selectează vizita",
    "download": "Descarcă PDF",
    "empty": "Nu există lucrări autorizate pentru acest vehicul la această locație.",
    "limits": "Selectează 1–20 de vizite de pe această pagină. Rapoartele acceptă cel mult 200 de servicii, 12 fotografii, 80 de pagini și 10 MB. Exportă istoricul mare în selecții mai mici.",
    "open": "Istoric de servicii pentru vehicul"
  },
  "payments": {
    "overdue_summary": "{{count}} lucrări au un avans restant, inclusiv programări în afara intervalului acestui panou.",
    "review_overdue": "Verifică avansurile restante",
    "all_jobs": "Arată toate lucrările",
    "title": "Plăți și avansuri",
    "record": "Înregistrează bani externi",
    "request": "Solicită un avans",
    "external_help": "Înregistrează doar banii încasați, restituiți sau corectați efectiv în afara GarageClerk. Acțiunea nu încasează bani, nu emite facturi și nu modifică abonamentul. Fiecare înregistrare nouă reprezintă o mișcare separată; reîncearcă aceeași înregistrare doar pentru aceeași mișcare.",
    "request_help": "Solicitarea cere o sumă suplimentară din totalul confirmat curent. Nu înregistrează bani. Încasările ulterioare sting întâi cele mai vechi solicitări, inclusiv cele fără legătură cu o solicitare. Fiecare ban se numără o singură dată. Avansurile restante alertează personalul fără anularea programării.",
    "selected_request": "Solicitare de avans",
    "kind": "Tipul înregistrării",
    "amount": "Sumă",
    "amount_help": "Folosește cel mult două zecimale. Introdu restituirile ca sume pozitive; doar corecțiile pot fi negative. Restituirile și corecțiile negative necesită un administrator sau manager.",
    "method": "Metodă externă",
    "reference": "Referința chitanței sau transferului",
    "occurred_at": "Data reală a mișcării",
    "recorded_at": "Data înregistrării",
    "reason": "Motiv pentru audit",
    "time_help": "Folosește data/ora ISO cu un decalaj UTC explicit, de exemplu 2026-11-02T10:00:00+02:00. Locația afișării: {{zone}}. Păstrează ora reală, inclusiv pentru încasări istorice.",
    "request_kind": "Baza avansului",
    "fixed": "Sumă fixă",
    "percentage": "Procent din totalul confirmat",
    "value": "Sumă sau procent",
    "due_at": "Scadent la",
    "total": "Total servicii confirmat",
    "received": "Încasat net",
    "outstanding": "Sold restant al lucrării",
    "credit": "Încasat în plus",
    "requests": "Solicitări de avans",
    "entries": "Istoricul banilor",
    "no_requests": "Nu există solicitări de avans.",
    "empty": "Nu sunt înregistrați bani externi.",
    "overdue": "Avans restant. Contactează clientul; programarea rămâne confirmată.",
    "requested": "Sumă solicitată",
    "request_remaining": "Avans încă datorat",
    "receive_advance": "Înregistrează avansul încasat",
    "allocated": "Legat de o solicitare pentru audit; încasările sting întâi cele mai vechi solicitări.",
    "kinds": {
      "payment": "Plată încasată",
      "advance": "Avans încasat",
      "refund": "Restituire externă",
      "adjustment": "Corecție externă",
      "reconciliation": "Reconciliere sold extern"
    },
    "methods": {
      "cash": "Numerar",
      "bank_transfer": "Transfer bancar",
      "card": "Plată externă cu cardul",
      "other": "Altele"
    }
  },
  "product_consumptions": {
    "quantity": "Cantitate reală consumată",
    "title": "Consum real de produse",
    "record": "Înregistrează consum real",
    "product": "Produs",
    "help": "Doar consum real, opțional. Progresul lucrării și estimările serviciilor nu scad stocul. Fiecare înregistrare nouă reprezintă un consum real suplimentar.",
    "no_products": "Adaugă un produs în Stoc înainte de a înregistra consumul real.",
    "correction_help": "Stoc insuficient? Înregistrează doar o recepție reală sau un inventar fizic într-o filă separată, apoi revino aici și reîncearcă.",
    "empty": "Nu există consum real de produse înregistrat."
  },
  "billing_reviews": {
    "current_total": "Total servicii verificat: {{amount}}",
    "title": "Verificare facturare",
    "prepare": "Pregătește facturarea",
    "prepare_help": "Păstrează sau elimină serviciile acceptate, ajustează prețurile și reducerile ori adaugă un serviciu disponibil. Salvează o previzualizare privată înainte de partajare sau confirmare.",
    "include": "Include acest serviciu",
    "line_discount": "Reducere pe serviciu (sumă)",
    "line_percentage": "Reducere pe serviciu (%)",
    "job_discount": "Reducere pe lucrare (sumă)",
    "job_percentage": "Reducere pe lucrare (%)",
    "advance": "Avans încasat de dedus",
    "advance_help": "Banii încasați reduc suma de plată. Nu reduc totalul serviciilor sau taxele.",
    "due": "Sumă de plată după avans",
    "received": "Bani înregistrați ca încasați: {{amount}}",
    "billing_details": "Date de facturare",
    "details_help": "Aceste date sunt separate de profilul clientului. Furnizorul de facturi ales poate solicita informații suplimentare înainte de emitere.",
    "name": "Nume pentru facturare",
    "country": "Țară de facturare",
    "address": "Adresă de facturare",
    "tax_identifier": "Identificator fiscal",
    "preview": "Salvează și previzualizează",
    "increase": "Acest total depășește condițiile acceptate inițial. Obține din nou aprobarea clientului pentru această versiune exactă înainte de confirmarea finală.",
    "confirm_terms": "Am verificat aceste servicii, sume și date de facturare exacte.",
    "publish": "Confirmă și partajează verificarea",
    "published": "Clientul poate accesa verificarea prin link. Previzualizează și confirmă separat un e-mail pentru a-l trimite.",
    "offline": "Înregistrează aprobarea clientului",
    "method": "Metodă de aprobare",
    "phone": "Telefonic",
    "in_person": "În persoană",
    "who": "Cine a aprobat",
    "at": "Data și ora aprobării (include decalajul UTC)",
    "what": "Ce a aprobat clientul",
    "record_approval": "Înregistrează aprobarea explicită",
    "approval_saved": "Aprobarea clientului a fost înregistrată",
    "confirm": "Confirmă verificarea finală",
    "confirmed_notice": "Verificarea finală a fost confirmată. Nu a fost emisă sau trimisă o factură.",
    "stale": "Lucrarea sau condițiile s-au schimbat. Pregătește o verificare nouă pe baza lucrării actuale.",
    "link": "Link de verificare pentru client",
    "open": "Deschide verificarea facturării",
    "approve": "Aprobă aceste condiții exacte",
    "reassign": "Reatribuie responsabilitatea facturării",
    "verified_customer": "Client verificat",
    "link_access": "Link client",
    "staff": "Personal",
    "states": {
      "draft": "Previzualizare privată",
      "proposed": "Partajat pentru verificare",
      "approved": "Aprobat de client",
      "declined": "Refuzat de client",
      "confirmed": "Verificare finală confirmată"
    }
  },
  "job_board": {
    "physical_bay": "Post fizic",
    "capacity_started_at": "Sosire fizică înregistrată",
    "capacity_released_at": "Post eliberat la",
    "capacity_states": {
      "hold": "Post blocat temporar",
      "confirmed": "Post rezervat",
      "in_progress": "Post ocupat",
      "released": "Post eliberat",
      "expired": "Blocarea postului a expirat"
    },
    "title": "Panou lucrări",
    "history": "Caută în istoricul lucrărilor",
    "range": "De făcut: lucrări restante și {{from}}–{{through}} · {{zone}}",
    "done_help": "Lucrările încheiate rămân aici cinci zile după plată și predare, apoi în istoricul lucrărilor.",
    "empty": "Nicio lucrare în această etapă.",
    "pages": "Pagini {{stage}}",
    "balance": "Rest de plată: {{amount}}",
    "received": "Încasat: {{amount}}",
    "collected": "Vehicul predat",
    "send_arrival": "Trimiți notificarea de sosire?",
    "send_yes": "Trimite notificarea",
    "send_no": "Continuă fără notificare",
    "start": "Începe lucrarea",
    "complete": "Marchează gata de predare",
    "billing": "Predare la facturare",
    "billing_help": "Alege administratorul sau managerul responsabil de facturare. Lucrarea se finalizează și postul se eliberează la trecerea în Facturare.",
    "billing_assignee": "Responsabil de facturare",
    "no_billing_staff": "Un administrator trebuie să activeze un responsabil eligibil pentru facturare la această locație.",
    "bill": "Treci în Facturare",
    "collection_help": "Înregistrează predarea fizică separat de plată. Încheierea necesită atât predarea, cât și plata integrală.",
    "collect": "Înregistrează predarea",
    "cancel_title": "Anulare sau neprezentare",
    "cancel_help": "Înregistrează motivul și eliberează rezervarea. Istoricul plăților se păstrează; această acțiune nu emite rambursări.",
    "cancel_type": "Rezultat",
    "reason": "Motiv",
    "cancel": "Înregistrează rezultatul",
    "events": "Vezi istoricul activității",
    "search": "Caută după client, vehicul sau număr de înmatriculare",
    "search_button": "Caută",
    "arrived_at": "Sosire în atelier",
    "completed_at": "Lucrare finalizată",
    "collected_at": "Vehicul predat",
    "done_at": "Lucrare încheiată",
    "cancelled_at": "Rezultat înregistrat",
    "stages": {
      "to_do": "De făcut",
      "in_progress": "În lucru",
      "ready_for_collection": "Gata de predare",
      "billing": "Facturare",
      "done": "Încheiat",
      "cancelled": "Anulat",
      "no_show": "Neprezentare"
    }
  },
  "notifications": {
    "action_required": "Un email necesită intervenție. Deschide istoricul emailurilor pentru a verifica eșecul sau livrarea incertă.",
    "preview": "Previzualizează emailul",
    "history": "Istoric emailuri",
    "recipient": "Destinatar",
    "no_email": "Nu există email salvat",
    "confirm": "Confirmă și adaugă emailul în coadă",
    "retry": "Reîncearcă livrarea",
    "attempts": "Încercări de livrare",
    "empty": "Niciun email nu a fost adăugat în coadă.",
    "queued": "Email adăugat în coadă. Verifică istoricul pentru starea livrării.",
    "stale": "Conținutul sau destinatarul s-a schimbat. Verifică previzualizarea curentă înainte de confirmare.",
    "verified_email_required": "Solicită clientului să verifice emailul salvat înainte de trimitere. Mesajele de verificare sunt permise.",
    "superseded": "Acest mesaj nu mai este actual. Previzualizează propunerea sau programarea curentă.",
    "undeliverable": "Furnizorul a raportat că emailul nu a putut fi livrat. Contactează clientul și corectează sau verifică emailul înainte de un mesaj nou.",
    "provider_failure": "Furnizorul de email nu a confirmat acceptarea. Verifică configurarea și reîncearcă același mesaj.",
    "reconciliation_required": "Livrarea este incertă. Verifică înregistrarea furnizorului înainte de a contacta clientul; reîncercarea automată este blocată pentru a preveni duplicatele.",
    "sent_help": "Trimis înseamnă că furnizorul de email configurat a acceptat mesajul. Nu confirmă primirea de către client. Mesajele eșuate sau incerte necesită intervenția personalului.",
    "states": {
      "queued": "În coadă",
      "sending": "Se trimite — acceptarea nu este confirmată",
      "sent": "Trimis către furnizorul de email",
      "failed": "Eșuat — necesită intervenție",
      "retried": "Reîncercat"
    }
  },
  "website_requests": {
    "contact": "Datele tale de contact",
    "customer": "Profilul tău salvat la companie",
    "new_details": "Introdu date noi",
    "vehicle": "Vehiculul tău",
    "new_vehicle": "Introdu alt vehicul",
    "name": "Nume",
    "email": "Email",
    "phone": "Telefon (opțional, cu prefix internațional)",
    "privacy": "Verifică emailul înainte de trimiterea solicitării. Profilurile salvate sunt disponibile doar după autentificarea autorizată. Contactele existente nu sunt îmbinate sau suprascrise.",
    "photos": "Fotografii (opțional)",
    "photos_help": "Cel mult 8 fotografii JPEG, PNG, WebP sau GIF, de 10 MB fiecare. Fotografiile rămân private.",
    "service": "Servicii și interval dorit",
    "describe_service": "Descrie serviciul mai jos",
    "service_details": "Servicii solicitate",
    "body": "Mesajul tău",
    "desired_start": "Început dorit",
    "desired_end": "Sfârșit dorit",
    "interval_help": "Introdu datele și orele în fusul orar al locației: {{zone}}. Este o preferință; echipa verifică disponibilitatea și trimite o propunere. Nu se rezervă niciun post.",
    "start_offset": "Decalaj UTC pentru început",
    "end_offset": "Decalaj UTC pentru sfârșit",
    "choose_offset": "Alege apariția orei",
    "submit": "Salvează și verifică emailul",
    "resend": "Salvează modificările și retrimite verificarea",
    "verification_sent": "Ciorna privată este salvată. Verifică emailul și confirmă linkul pentru a o trimite. Poți corecta datele și retrimite verificarea.",
    "submitted": "Solicitarea a fost trimisă. Echipa va verifica datele și disponibilitatea. Parola este opțională pentru trimitere și obligatorie pentru accesul la istoric.",
    "another": "Trimite altă solicitare",
    "delivery_failed": "Ciorna privată este salvată, dar emailul de verificare nu a putut fi trimis. Încearcă din nou.",
    "retry": "Verifică datele ciornei înainte de trimitere. Revino la solicitare, corectează datele și cere un nou email de verificare.",
    "pending": "Acestea sunt datele trimise. Completează identitatea clientului folosind decizia existentă de potrivire a contactelor înainte de a trimite o propunere.",
    "snapshot": "Date trimise prin site",
    "continue": "Continuă în siguranță la solicitare"
  },
  "domains": {
    "auth_unavailable": "Autentificarea clienților așteaptă gazda HTTPS principală a aplicației. Contactează GarageClerk pentru finalizarea găzduirii.",
    "title": "Domeniu propriu",
    "help": "Folosește o singură gazdă CNAME, de exemplu programari.compania-ta.com. Introdu doar numele gazdei, fără protocol, cale sau port. Site-ul companiei trebuie publicat separat.",
    "hostname": "Numele gazdei site-ului",
    "save": "Salvează domeniul",
    "verify": "Verifică proprietatea și disponibilitatea",
    "remove": "Elimină domeniul",
    "plan_required": "Domeniile proprii necesită un abonament Plus sau Pro activ ori perioada de probă cu funcții Plus. Gazda salvată este păstrată cât timp funcția nu este disponibilă.",
    "saved": "Domeniul a fost salvat. Adaugă înregistrările DNS, apoi verifică proprietatea și disponibilitatea.",
    "removed": "Domeniul a fost eliminat.",
    "checked": "Verificarea domeniului s-a încheiat. Consultă starea curentă de mai jos.",
    "conflict": "Această gazdă este deja configurată. Alege alta sau contactează asistența pentru clarificarea proprietății.",
    "txt_name": "Numele înregistrării TXT",
    "txt_value": "Valoarea înregistrării TXT",
    "cname": "Destinația CNAME pentru gazda ta",
    "target_missing": "Destinația de găzduire nu este configurată. Comunică gazda dorită echipei GarageClerk; operatorul trebuie să furnizeze destinația CNAME aprobată și să activeze rutarea și TLS.",
    "tls_help": "Propagarea DNS poate dura. Păstrează înregistrarea TXT. Gazda aprobată trebuie să emită un certificat; salvarea domeniului nu emite unul. Verificările se reiau automat după 12 ore dacă procesul de sarcini din producție funcționează. Rutarea se oprește dacă dovada depășește 24 de ore, certificatul expiră sau accesul abonamentului încetează.",
    "refresh_required": "Rutarea nu este disponibilă. Verifică din nou DNS, certificatul și configurația găzduirii.",
    "checked_at": "Ultima verificare: {{date}}",
    "ownership_at": "Proprietate verificată: {{date}}",
    "certificate_at": "Certificatul expiră: {{date}}",
    "states": {
      "pending": "În așteptare: publică înregistrarea TXT, apoi verifică proprietatea.",
      "ownership_required": "Proprietate neverificată: publică exact înregistrarea TXT de mai jos și reîncearcă.",
      "hosting_required": "Proprietate verificată; operatorul trebuie să configureze destinația de găzduire aprobată înainte de verificarea DNS și TLS.",
      "dns_required": "Proprietate verificată; gazda trebuie să aibă un CNAME către destinația de mai jos.",
      "tls_required": "Proprietate și CNAME verificate; este necesar un certificat HTTPS public valid pentru această gazdă. Solicită operatorului emiterea sau reînnoirea lui.",
      "failed": "Verificarea DNS sau TLS a eșuat. Verifică propagarea DNS, destinația publică și certificatul, apoi reîncearcă.",
      "ready": "Proprietatea, CNAME și certificatul HTTPS public au fost verificate. Site-ul publicat poate folosi această gazdă cât timp verificările și accesul abonamentului rămân valabile."
    }
  },
  "website": {
    "title": "Site-ul companiei",
    "saved": "Setările site-ului au fost salvate.",
    "public_help": "Vizitatorii văd doar conținutul publicat. Publică locațiile și selectează serviciile pe care dorești să le afișezi. Textele sunt afișate ca text simplu.",
    "brand_name": "Numele public al companiei",
    "headline_en": "Titlu în engleză",
    "headline_ro": "Titlu în română",
    "description_en": "Prezentare în engleză",
    "description_ro": "Prezentare în română",
    "publish_site": "Publică site-ul companiei",
    "publish_location": "Publică această locație",
    "location_description": "Descrierea publică a locației",
    "public_services": "Servicii publice",
    "services_help": "Apar public doar serviciile selectate, disponibile și în moneda locației. Serviciile arhivate sunt ascunse.",
    "save": "Salvează site-ul",
    "save_location": "Salvează pagina locației",
    "view": "Vezi site-ul public",
    "choose_location": "Alege o locație",
    "all_locations": "Toate locațiile",
    "services": "Servicii",
    "empty_services": "Nu sunt publicate servicii pentru această locație.",
    "enquire": "Întreabă la această locație",
    "enquire_service": "Întreabă despre acest serviciu",
    "entry_title": "Locația solicitării tale",
    "entry_help": "Completează datele, apoi verifică emailul pentru a trimite solicitarea. Echipa va verifica disponibilitatea.",
    "sign_in": "Autentificare client",
    "signed_in": "Ești autentificat. Alege profilul salvat autorizat sau introdu date noi.",
    "history": "Vezi istoricul tău de client",
    "back": "Înapoi la locație",
    "minutes": "{{count}} minute",
    "inclusive": "Taxă inclusă",
    "exclusive": "Taxă adăugată",
    "locations": "Locații",
    "language": "Limba paginii: {{language}}",
    "en": "Engleză",
    "ro": "Română",
    "unpublished": "Salvează și publică site-ul pentru a-l face vizibil.",
    "no_locations": "Nu sunt locații publicate în acest moment."
  },
  "proposals": {
    "legacy_help": "Această propunere anterioară nu are o rezervare temporară. Cere echipei să o verifice, să aleagă responsabilul și să o republice înainte de a răspunde. Serviciile, prețurile și intervalul inițial rămân afișate.",
    "expired": "Rezervarea temporară a expirat la {{expiry}}; postul nu mai este rezervat.",
    "suggestion_help": "Sugestia nu rezervă un alt interval. Postul inițial rămâne rezervat numai până la expirarea afișată; echipa va verifica disponibilitatea. Poți accepta în continuare propunerea inițială.",
    "accept": "Acceptă și confirmă programarea",
    "publish_hold": "Publicarea va rezerva temporar postul timp de {{hours}} ore și va afișa clientului expirarea.",
    "read_only": "Propunerea poate fi doar consultată cât timp accesul operațional al echipei nu este disponibil. Contactează echipa pentru a continua.",
    "suggestion_status": "Interval alternativ solicitat: {{time}}. Echipa trebuie să verifice disponibilitatea; niciun alt interval nu este rezervat.",
    "declined_status": "Propunere refuzată. Rezervarea temporară a fost eliberată.",
    "accepted_status": "Programare confirmată pentru serviciile, prețurile și intervalul de mai sus.",
    "accept_help": "Acceptarea confirmă serviciile, prețurile și intervalul inițial afișate mai sus.",
    "decline_note": "Motiv (opțional)",
    "alternative": "Intervalul alternativ preferat",
    "suggest": "Propune alt interval",
    "decline": "Refuză propunerea",
    "decision": "Decizia ta",
    "expiry_help": "După termen, acceptarea verifică din nou disponibilitatea. Echipa poate propune un alt interval.",
    "held_until": "Postul de lucru este rezervat temporar până la {{expiry}}.",
    "hold": "Rezervare temporară",
    "history": "Versiuni publicate (ultimele 30)",
    "title": "Propunere de servicii",
    "compose": "Compune propunerea",
    "preview": "Previzualizare client",
    "edit": "Editează ciorna privată",
    "publish": "Publică propunerea",
    "save_preview": "Salvează și previzualizează",
    "private_help": "Ciornă privată. Clienții văd numai ultima versiune publicată.",
    "capacity_help": "Publicarea rezervă temporar postul până la expirarea afișată. Acceptarea confirmă programarea după verificarea disponibilității.",
    "view_help": "Verifică serviciile, prețurile și intervalul afișate înainte de a decide.",
    "link": "Link de vizualizare autorizat",
    "delivery_help": "Oricine are acest link poate vedea și răspunde la propunere. Copiază-l numai către clientul vizat, prin canalul convenit. Publicarea nu trimite un mesaj.",
    "open": "Deschide vizualizarea clientului",
    "recompose": "Clientul, vehiculul sau locația cererii s-a schimbat. Recompune și verifică ciorna înainte de publicare.",
    "quantity": "Cantitate",
    "unit_price": "Preț unitar",
    "discount_amount": "Reducere pe linie (sumă în monedă)",
    "discount_percentage": "Reducere pe linie (%)",
    "discount": "Reducere",
    "overall_discount": "Reducere totală (moneda propunerii)",
    "net": "Valoare netă",
    "tax": "Taxă",
    "total": "Total",
    "inclusive": "Taxă inclusă",
    "exclusive": "Taxă adăugată"
  },
  "requests": {
    "partial_help": "Salvează datele cunoscute. Profilurile complete ale clientului și vehiculului sunt create odată cu solicitarea; datele incomplete pot fi adăugate ulterior.",
    "new_customer": "Client nou",
    "choose_customer": "Clientul acestei solicitări",
    "search_customers": "Caută clienți salvați",
    "associate_first": "Salvează reutilizarea clientului înainte de a alege vehiculele sale.",
    "staged_help": "Clientul și vehiculul noi sunt create când salvezi solicitarea.",
    "draft_restored": "Datele nesalvate ale solicitării au fost restaurate.",
    "photo_reselect": "Selectează din nou fotografiile nesalvate după reîncărcarea paginii.",
    "saved_photo_help": "Fotografiile vehiculului rămân cu solicitarea și sunt adăugate profilului noului vehicul când acesta este creat.",
    "customer_associated": "Client reutilizat. Alege vehiculul pentru a completa solicitarea.",
    "use_customer": "Folosește clientul și alege vehiculul",
    "choose_vehicle": "Vehiculul acestei solicitări",
    "new_vehicle": "Introdu un vehicul nou",
    "search_vehicles": "Caută vehicule salvate",
    "vehicle_help": "Alege vehiculul salvat al clientului sau introdu altul. Lucrările și fotografiile altor locații rămân private.",
    "intake_location": "Locația inițială",
    "title": "Solicitări",
    "cell": {
      "customer": "Client",
      "contact": "Contact",
      "customer_contact": "Client / Contact",
      "vehicle": "Vehicul",
      "request": "Solicitare",
      "no_contact": "Fără date de contact",
      "no_vehicle": "Fără detalii despre vehicul",
      "no_registration": "Fără număr de înmatriculare"
    },
    "add": "Adaugă o solicitare",
    "save": "Salvează solicitarea",
    "saved": "Solicitarea a fost salvată.",
    "routed": "Solicitarea a fost redirecționată.",
    "stale": "Solicitarea s-a modificat. Verifică detaliile actuale și încearcă din nou.",
    "search": "Caută solicitări",
    "state": "Stare",
    "all": "Toate stările",
    "filter": "Filtrează",
    "empty": "Nu există solicitări aici.",
    "unnamed": "Solicitare fără nume",
    "pages": "Paginile solicitărilor",
    "previous": "Înapoi",
    "next": "Înainte",
    "page": "Pagina {{page}} din {{pages}}",
    "channel": "Canal de origine",
    "channel_identity": "Identificatorul canalului",
    "body": "Mesajul solicitării",
    "service_details": "Servicii solicitate",
    "details": "Detaliile solicitării",
    "complete": "Detalii complete",
    "incomplete": "Sunt necesare detalii suplimentare",
    "services_missing": "Serviciile solicitate nu au fost încă precizate.",
    "intake_help": "Înregistrează o solicitare la această locație. Detaliile clientului sau vehiculului pot fi completate ulterior. Formularul nu conectează și nu trimite mesaje către un furnizor.",
    "identity_help": "Pentru solicitări sociale, introdu identificatorul conversației sau al expeditorului. Acesta nu verifică identitatea clientului.",
    "complete_details": "Completează detaliile",
    "completion_help": "Numele clientului, un email sau telefon internațional, marca/modelul vehiculului și serviciile solicitate sunt obligatorii înainte de o propunere sau lucrare confirmată.",
    "save_details": "Salvează detaliile",
    "correct_contacts": "Creează client / corectează contactele",
    "saved_customer_help": "Reutilizarea folosește detaliile salvate ale clientului ales. Contactele introduse sunt verificate doar pentru o potrivire exactă și nu suprascriu clientul salvat.",
    "view_job": "Vezi lucrarea confirmată",
    "record_response": "Înregistrează un răspuns",
    "response_help": "Înregistrează un răspuns sau o decizie deja comunicată în afara GarageClerk. Această acțiune nu trimite mesaje.",
    "action": "Tipul răspunsului",
    "note": "Detaliile răspunsului sau deciziei",
    "suggested_time": "Intervalul sugerat de client",
    "suggestion_help": "Este doar o sugestie. Nu rezervă un post de lucru și nu reprogramează o lucrare confirmată.",
    "record": "Înregistrează răspunsul",
    "route": "Redirecționează solicitarea",
    "routing_help": "Mută solicitarea fără ofertă la altă locație permisă. Locația inițială și istoricul solicitării se păstrează.",
    "history": "Istoricul solicitării",
    "system": "Sistem",
    "updated": "Actualizat",
    "states": {
      "new": "Nouă",
      "responded": "Cu răspuns",
      "accepted": "Acceptată",
      "declined": "Refuzată",
      "rescheduled": "Reprogramată"
    },
    "actions": {
      "responded": "Răspuns deja comunicat",
      "declined": "Refuz deja comunicat",
      "rescheduled": "Interval alternativ sugerat"
    },
    "history_actions": {
      "details_saved": "Detaliile solicitării au fost salvate",
      "whatsapp_intake": "Solicitare WhatsApp primită",
      "whatsapp_message": "Mesaj WhatsApp primit",
      "instagram_intake": "Solicitare Instagram primită",
      "website_intake": "Solicitare trimisă prin site",
      "customer_associated": "Client reutilizat",
      "intake": "Solicitare primită",
      "complete": "Detalii completate",
      "responded": "Răspuns înregistrat",
      "declined": "Refuz înregistrat",
      "rescheduled": "Interval alternativ sugerat",
      "routed": "Solicitare redirecționată",
      "staff_booking": "Acceptată prin rezervare de către echipă"
    },
    "channels": {
      "website": "Site",
      "manual": "Manual",
      "phone": "Telefon",
      "walk_in": "La sediu",
      "facebook": "Facebook",
      "instagram": "Instagram",
      "whatsapp": "WhatsApp"
    }
  },
  "jobs": {
    "title": "Lucrări",
    "create": "Creează o lucrare",
    "creation": {
      "steps": "Pașii creării lucrării",
      "customer": "Client",
      "vehicle": "Vehicul",
      "details": "Detaliile programării",
      "help": "Alege clientul și vehiculul, apoi confirmă lucrarea și programarea.",
      "cancel": "Renunță",
      "choose_customer": "Alege clientul",
      "choose_vehicle": "Alege vehiculul",
      "change_customer": "Schimbă clientul",
      "change_selection": "Schimbă clientul sau vehiculul",
      "search_label": "Caută după nume, email sau telefon",
      "search": "Caută",
      "clear_search": "Șterge căutarea",
      "no_customers": "Nu există clienți disponibili în această locație. Adaugă un client sau folosește Clienți pentru a găsi și reutiliza un profil existent.",
      "no_matches": "Niciun client nu corespunde căutării. Încearcă alt nume, email sau telefon ori șterge căutarea.",
      "no_vehicles": "Nu există vehicule disponibile pentru acest client în această locație. Adaugă un vehicul sau deschide profilul clientului pentru a reutiliza unul existent.",
      "manage_customers": "Gestionează clienții și reutilizează profiluri existente",
      "manage_vehicles": "Deschide profilul clientului și reutilizează vehicule"
    },
    "new": "Confirmă o lucrare",
    "confirm": "Confirmă lucrarea",
    "created": "Lucrare confirmată.",
    "confirmed": "Lucrare confirmată",
    "choose": "Alege…",
    "intake_help": "Confirmă lucrări telefonice sau la fața locului folosind clientul și vehiculul salvat. Verificarea emailului clientului nu este necesară.",
    "interval": "Post și interval",
    "bay_id": "Post de lucru",
    "starts_at": "Început",
    "ends_at": "Sfârșit",
    "zone_help": "Introdu ora locală a acestei locații: {{zone}}.",
    "occurrence": "Oră repetată",
    "first_occurrence": "Prima apariție (UTC{{offset}})",
    "second_occurrence": "A doua apariție (UTC{{offset}})",
    "helpers": "Ajutoare (opțional)",
    "team": "Echipă",
    "assignee_id": "Responsabil",
    "team_help": "Alege un responsabil. Ajutoarele trebuie să fie persoane diferite. Suprapunerile echipei sunt semnalate după confirmare.",
    "services": "Servicii",
    "quantity": "Cantitate",
    "minutes": "{{count}} minute",
    "no_services": "Nu există servicii disponibile. Cere unui administrator să configureze ofertele locației.",
    "no_bays": "Nu există posturi disponibile. Cere unui administrator să configureze un post de lucru.",
    "booking": "Detaliile programării",
    "no_helpers": "Niciunul",
    "overlap": "Suprapunere în echipă",
    "overlap_help": "Un responsabil sau ajutor are și alte lucrări în acest interval la această locație. Lucrarea este confirmată; coordonează echipa.",
    "net_minor": "Net",
    "tax_minor": "Taxă",
    "total_minor": "Total",
    "terms_help": "Acestea sunt serviciile, prețurile și datele clientului păstrate la confirmarea lucrării.",
    "progress": "Lucru, plată și preluare",
    "work": "Lucru",
    "payment": "Plată",
    "collection": "Preluare",
    "to_do": "De făcut",
    "unpaid": "Neplătită",
    "not_collected": "Nepreluat",
    "choose_vehicle": "Alege clientul și vehiculul",
    "entry_help": "Folosește Creează o lucrare pentru a alege clientul și vehiculul, apoi confirmă programarea.",
    "empty": "Nu există lucrări confirmate la această locație.",
    "stale": "Clientul, vehiculul sau condițiile serviciului s-au schimbat. Verifică datele actualizate și confirmă din nou."
  },
  "bays": {
    "title": "Posturi de lucru",
    "description": "Configurează spațiile fizice de lucru ale acestei locații. Rezervările continuă noaptea și în afara programului.",
    "add": "Adaugă post",
    "edit": "Editează postul",
    "edit_named": "Editează {{name}}",
    "name": "Denumirea postului",
    "availability": "Disponibilitate",
    "enabled": "Disponibil pentru rezervări noi",
    "disabled": "Indisponibil pentru rezervări noi",
    "availability_help": "Rezervările existente rămân valabile când un post devine indisponibil.",
    "empty": "Nu există posturi de lucru configurate.",
    "hold_hours": "Durata rezervării pentru propunere (ore)",
    "hold_help": "Rezervările pentru propuneri noi expiră după acest număr de ore efective. Rezervările existente păstrează expirarea comunicată.",
    "hold_summary": "Rezervările pentru propuneri noi durează {{hours}} ore.",
    "configure_hold": "Configurează durata rezervării"
  },
  "inventory": {
    "title": "Stocuri",
    "add": "Adaugă produs",
    "edit": "Editează numele produsului",
    "name": "Numele produsului",
    "unit": "Unitate",
    "litre": "Litri",
    "piece": "Bucăți",
    "unit_locked": "Unitatea rămâne fixă pentru a păstra semnificația cantităților anterioare.",
    "local_help": "Stocul și istoricul său aparțin locației {{location}}.",
    "empty": "Nu există produse de detailing înregistrate în această locație.",
    "low_empty": "Niciun produs nu este la sau sub pragul de stoc redus.",
    "all": "Toate produsele",
    "low_only": "Stoc redus",
    "low": "Stoc redus",
    "normal": "Peste prag",
    "disabled": "Nestabilit",
    "balance": "Stoc disponibil",
    "threshold": "Prag de stoc redus",
    "save": "Salvează",
    "cancel": "Anulează",
    "history": "Istoricul stocului",
    "no_history": "Nu există încă modificări ale stocului.",
    "receipt": "Înregistrează recepție",
    "correction": "Înregistrează inventar fizic",
    "threshold_action": "Setează pragul de stoc redus",
    "receipt_help": "Adaugă cantitatea recepționată efectiv. Aceasta mărește stocul curent.",
    "correction_help": "Introdu cantitatea totală numărată fizic. Aceasta înlocuiește stocul afișat; dacă stocul se schimbă între timp, verifică și reîncearcă.",
    "threshold_help": "Avertizează când stocul este la sau sub această cantitate. Lasă necompletat pentru a dezactiva avertizarea.",
    "precision_litre": "Introdu litri cu maximum trei zecimale. Sunt acceptate virgula sau punctul zecimal.",
    "precision_piece": "Introdu un număr întreg de bucăți.",
    "quantity": "Cantitate recepționată",
    "count": "Cantitate totală numărată fizic",
    "reason": "Motiv",
    "reason_help": "Explică recepția, inventarul fizic sau schimbarea pragului pentru istoricul echipei.",
    "kind_receipt": "Recepție",
    "kind_correction": "Corecție după inventarul fizic",
    "kind_decrement": "Stoc utilizat",
    "kind_threshold": "Schimbare de prag",
    "quantity_change": "{{before}} → {{after}} (diferență: {{change}})",
    "threshold_change": "Prag: {{before}} → {{after}}",
    "by": "{{actor}} · {{time}}",
    "previous": "Anterior",
    "next": "Următor"
  },
  "vehicles": {
    "reuse": "Folosește vehiculul existent",
    "reuse_help": "Acest client are vehicule la altă locație. Reutilizează un vehicul pentru a-l adăuga aici; lucrările și fotografiile celeilalte locații rămân private.",
    "title": "Vehicule",
    "add": "Adaugă vehicul",
    "edit": "Editează vehiculul",
    "save": "Salvează vehiculul",
    "details": "Datele vehiculului",
    "manual_help": "Alege o sugestie sau introdu orice marcă și model. Acoperirea este incompletă, inclusiv în România și SUA. Anul de fabricație este independent; celelalte date sunt opționale.",
    "catalogue_empty": "Nu există sugestii. Continuă să scrii pentru a folosi propria valoare.",
    "catalogue_credit": "Date despre vehicule de la",
    "catalogue_notices": "Surse și modificări",
    "catalogue_changes": "Nume grupate și deduplicate de GarageClerk. Fără susținere oficială.",
    "make": "Marcă",
    "model": "Model",
    "fabrication_year": "An de fabricație",
    "colour": "Culoare",
    "registration_number": "Număr de înmatriculare",
    "vin": "Serie șasiu / VIN",
    "photos": "Fotografii",
    "photo_help": "Păstrează cel mult 10 fotografii în această locație și încarcă cel mult 10 la o salvare. Folosește JPEG, PNG, WebP sau GIF de maximum 10 MB fiecare. Fotografiile existente se păstrează dacă nu sunt selectate pentru eliminare.",
    "remove_photo": "Elimină {{name}} din această versiune",
    "empty": "Acest client nu are încă vehicule în această locație.",
    "owner": "Proprietar actual",
    "owner_private": "Proprietarul actual nu este accesibil în această locație.",
    "transfer": "Transferă proprietatea",
    "transfer_help": "Alege un client existent din această locație. Accesul său include doar înregistrările proprii. Foștii proprietari își păstrează istoricul și fotografiile. Fotografiile actuale rămân doar la fostul proprietar; adaugă fotografii noi după transfer.",
    "new_owner": "Proprietar nou",
    "choose_owner": "Alege un client",
    "no_owner": "Nu există clienți potriviți. Adaugă sau reutilizează mai întâi un client în această locație.",
    "reason": "Notă (opțională)",
    "confirm_transfer": "Confirmă transferul",
    "search_owner": "Caută clienți după nume",
    "search": "Caută",
    "history": "Istoricul profilului vehiculului",
    "history_help": "Acțiunile din această locație, cu datele înregistrate atunci.",
    "actions": {
      "reused": "Vehicul existent adăugat",
      "created": "Vehicul adăugat",
      "edited": "Datele vehiculului au fost modificate",
      "transferred": "Proprietate transferată"
    }
  },
  "customers": {
    "pages": "Paginile clienților",
    "page": "Pagina {{page}} din {{pages}}",
    "previous": "Înapoi",
    "next": "Înainte",
    "title": "Clienți",
    "create": "Adaugă client",
    "edit": "Editează clientul",
    "save": "Salvează clientul",
    "details": "Datele clientului",
    "contact_required": "Introdu un nume și cel puțin un email sau telefon. Adresa este opțională.",
    "name": "Nume",
    "email": "Email",
    "phone": "Telefon",
    "address": "Adresă (opțională)",
    "cancel": "Anulează",
    "choose": "Alege un client existent",
    "reuse_help": "Alege un client cu datele sale salvate sau corectează contactele de mai sus și reîncearcă. Datele salvate rămân neschimbate. Istoricul altor locații rămâne privat.",
    "use_saved": "Folosește datele salvate",
    "matched": "Contact identificat",
    "not_supplied": "Nefurnizat",
    "empty": "Nu există încă clienți în această locație.",
    "phone_help": "Folosește un număr internațional, de exemplu +40712345678 sau 0040712345678."
  },
  "maps": {
    "title": "Previzualizare adresă și reper",
    "unavailable": "Previzualizarea hărții nu este disponibilă. Puteți salva adresa.",
    "address_hint": "Introduceți o adresă pentru a previzualiza reperul.",
    "notice": "Verificați dacă reperul corespunde locației înainte de salvare.",
    "interval_add": "Adaugă interval",
    "interval_remove": "Elimină interval"
  },
  "companies": {
    "no_location_title": "Fără acces la locații",
    "no_location_description": "Cere unui administrator al companiei acces la o locație sau schimbă compania.",
    "new_identity": "Creează o autentificare de membru",
    "switch": "Schimbă compania",
    "join_title": "Alătură-te companiei",
    "join_description": "Acceptă invitația cu identitatea ta de membru existentă.",
    "invited_as": "{{email}} · {{role}}",
    "accept": "Acceptă invitația",
    "wrong_identity": "Deconectează-te și autentifică-te cu adresa de email invitată."
  },
  "recovery": {
    "expired": "Expirat",
    "term_ended": "Perioada s-a încheiat la {{date}}.",
    "paid_terms": "{{plan}}, {{amount}} pe {{interval}}.",
    "trial_title": "Perioada de probă a expirat",
    "trial_description": "Abonează-te pentru a continua să folosești contul.",
    "payment_title": "Actualizează abonamentul",
    "payment_description": "Plata a eșuat sau abonamentul a expirat. Actualizează plata pentru a continua. În perioada de reîncercare poți reveni la lucru după confirmarea notificării.",
    "upgrade": "Abonează-te",
    "update_payment": "Actualizează plata",
    "subscribe": "Abonează-te",
    "delete_account": "Șterge contul",
    "logout": "Deconectare",
    "contact_title": "Este necesar un abonament",
    "contact_description": "Contactează un administrator al contului pentru restabilirea accesului.",
    "closure_description": "Închiderea contului retrage imediat accesul tuturor membrilor și anulează abonamentele recurente. Datele aplicației sunt șterse definitiv după 30 de zile, după confirmarea anulării. Contul nu poate fi redeschis din aplicație.",
    "confirm_name": "Scrie {{name}} pentru confirmare"
  },
  "common": {
    "account": "Cont",
    "activity": "Activitate",
    "add": "Adaugă",
    "back": "Înapoi",
    "billing": "Facturare",
    "cancel": "Anulează",
    "continue": "Continuă",
    "dashboard": "Panou",
    "language": "Limba",
    "locations": "Locații",
    "password": "Parolă",
    "profile": "Profil",
    "save": "Salvează",
    "saving": "Se salvează...",
    "schedule": "Program",
    "settings": "Setări",
    "sign_out": "Deconectare",
    "team": "Echipa",
    "location": "Locație",
    "close": "Închide",
    "more": "Mai multe",
    "loading": "Se încarcă",
    "sidebar": "Navigare",
    "sidebar_description": "Navigarea aplicației",
    "toggle_sidebar": "Comută navigarea",
    "breadcrumb": "Traseu de navigare"
  },
  "auth": {
    "continue_google": "Continuă cu Google",
    "email": "Adresa de e-mail",
    "forgot_password": "Ai uitat parola?",
    "forgot_description": "Resetează parola",
    "forgot_title": "Parolă uitată",
    "has_account": "Ai deja un cont?",
    "joining": "Te alături contului {{account}}",
    "login": "Autentificare",
    "no_account": "Ai nevoie de un cont?",
    "password": "Parolă",
    "password_confirmation": "Confirmă parola",
    "reset_submit": "Resetează parola",
    "reset_title": "Resetează parola",
    "save_password": "Salvează parola",
    "create_password": "Creează o parolă nouă",
    "signup": "Creează cont",
    "signup_description": "Creează un cont nou",
    "signup_title": "Înregistrare",
    "welcome": "Bine ai venit",
    "login_title": "Autentificare",
    "login_description": "Autentifică-te în cont",
    "or": "Sau"
  },
  "onboarding": {
    "account": "Cont",
    "account_name": "Numele contului",
    "first_name": "Prenume",
    "last_name": "Nume",
    "location": "Prima locație",
    "location_name": "Numele locației",
    "plan": "Plan",
    "profile": "Profil",
    "title": "Configurează spațiul de lucru",
    "team_size": "Mărimea echipei",
    "required": "Completează toate câmpurile obligatorii.",
    "trial_notice": "Începe o perioadă de probă de {{days}} zile cu funcțiile {{plan}}. Plata securizată solicită o metodă de plată; după probă, abonamentul {{post_plan}} costă {{amount}} pe {{interval}}. Poți anula din Facturare înainte de încheierea perioadei de probă.",
    "checkout": "Continuă la plata securizată",
    "step": "Pasul {{current}} din {{total}}"
  },
  "settings": {
    "account_description": "Gestionează detaliile comune ale acestui cont.",
    "activity_description": "Consultă modificările importante ale contului și locațiilor.",
    "billing_description": "Gestionează abonamentul, facturile și conectarea platformei de plăți.",
    "location_description": "Gestionează adresa, moneda și fusul orar al acestei locații.",
    "profile_description": "Actualizează datele personale, avatarul și aspectul.",
    "schedule_description": "Stabilește programul obișnuit al acestei locații.",
    "team_description": "Invită persoane, atribuie roluri și controlează accesul la locații."
  },
  "billing_ui": {
    "month": "lună",
    "current_plan": "Plan curent",
    "choose_plan": "Alege planul",
    "open_portal": "Deschide portalul de facturare",
    "invoices": "Facturi",
    "no_invoices": "Nu există facturi.",
    "plans": {
      "starter": {
        "name": "Start",
        "description": "Pentru un membru activ într-o locație."
      },
      "team": {
        "name": "Plus",
        "description": "Pentru până la cinci membri activi, roluri și domeniu propriu."
      },
      "business": {
        "name": "Pro",
        "description": "Pentru până la treizeci de membri activi, locații nelimitate și activitate la nivel de companie."
      }
    },
    "annual_total": "{{amount}} pe an, facturat anual.",
    "staff_limit": "Membri activi: {{count}}",
    "location_limit": "Locații active: {{count}}",
    "unlimited_locations": "Locații active nelimitate",
    "features": {
      "detailing_history": "Istoricul lucrărilor de detailing",
      "integrations": "Integrări disponibile",
      "custom_domains": "Domeniu propriu",
      "invitations": "Invitații",
      "user_roles": "Roluri de utilizator",
      "multiple_locations": "Locații multiple",
      "activity_logs": "Consola de activitate a companiei"
    },
    "monthly": "lună",
    "yearly": "an",
    "trial_end": "Perioada de probă se încheie pe {{date}}.",
    "next_bill": "Următoarea facturare: {{date}}.",
    "cancels": "Abonamentul se încheie la finalul perioadei curente.",
    "start_trial": "Începe plata pentru probă",
    "unavailable": "Facturarea nu este configurată pentru acest mediu. Contactează administratorul.",
    "future_terms": "După probă: {{plan}}, {{amount}} pe {{interval}}.",
    "trial_features": "Perioada de probă include funcțiile {{plan}}.",
    "statuses": {
      "trialing": "Probă",
      "active": "Activ",
      "past_due": "Plată întârziată",
      "unpaid": "Neplătit",
      "canceled": "Anulat",
      "incomplete": "Incomplet",
      "incomplete_expired": "Expirat",
      "paused": "Suspendat",
      "paid": "Plătită",
      "open": "Deschisă",
      "draft": "Ciornă",
      "void": "Anulată",
      "uncollectible": "Nerecuperabilă"
    }
  },
  "activity_ui": {
    "all_actions": "Toate acțiunile",
    "all_actors": "Toți autorii",
    "all_locations": "Toate locațiile",
    "all_subjects": "Toate subiectele",
    "action": "Acțiune",
    "from_date": "De la data",
    "to_date": "Până la data",
    "system": "Sistem",
    "empty": "Nu există activitate.",
    "previous": "Anterior",
    "next": "Următor",
    "subjects": {
      "Account": "Cont",
      "User": "Utilizator",
      "Location": "Locație",
      "Invitation": "Invitație"
    }
  },
  "profile_ui": {
    "choose_image": "Alege o imagine",
    "no_image": "Nicio imagine selectată",
    "avatar": "Avatar",
    "appearance": "Aspect",
    "light": "Luminos",
    "dark": "Întunecat",
    "system": "Sistem",
    "save_appearance": "Salvează modificările",
    "sessions": "Sesiuni",
    "unknown_browser": "Browser necunoscut",
    "current_session": "Sesiunea curentă",
    "revoke": "Revocă"
  },
  "fields": {
    "name": "Nume",
    "address_line_1": "Adresă, linia 1",
    "address_line_2": "Adresă, linia 2",
    "city": "Oraș",
    "region": "Județ / regiune",
    "postal_code": "Cod poștal",
    "country_code": "Țară",
    "currency": "Monedă",
    "time_zone": "Fus orar",
    "logo": "Sigla contului",
    "current_password": "Parola curentă"
  },
  "countries": {
    "RO": "România",
    "US": "Statele Unite",
    "GB": "Regatul Unit",
    "DE": "Germania"
  },
  "days": {
    "monday": "Luni",
    "tuesday": "Marți",
    "wednesday": "Miercuri",
    "thursday": "Joi",
    "friday": "Vineri",
    "saturday": "Sâmbătă",
    "sunday": "Duminică"
  },
  "schedule_ui": {
    "closed": "Închis",
    "opens_at": "Ora deschiderii",
    "closes_at": "Ora închiderii",
    "toggle": "Deschis {{day}}"
  },
  "locations_ui": {
    "description": "Creează locații și gestionează setările lor.",
    "add": "Adaugă locație",
    "new_description": "Adaugă o locație pentru echipa ta.",
    "limit": "Limita de locații a planului curent a fost atinsă."
  },
  "connect_ui": {
    "country": "Țara înregistrării legale a firmei",
    "select_country": "Selectează o țară",
    "country_help": "Alege țara în care este înregistrată legal firma. Stripe va verifica datele în timpul configurării.",
    "romania": "România",
    "united_states": "Statele Unite",
    "title": "Stripe Connect",
    "ready": "Plățile și transferurile sunt activate.",
    "description": "Conectează un cont pentru a primi plăți.",
    "continue": "Continuă configurarea Stripe",
    "start": "Conectează cu Stripe",
    "unavailable": "Stripe nu este configurat pentru acest mediu.",
    "restricted": "Stripe solicită informații suplimentare. Continuă configurarea pentru a le verifica."
  },
  "reschedules": {
    "title": "Reprogramează lucrarea confirmată",
    "original": "Programarea inițială confirmată",
    "replacement": "Înlocuirea propusă",
    "reason": "Motivul reprogramării",
    "communication": "Comunicarea cu clientul",
    "communication_help": "Înregistrează cum ai informat clientul (telefonic, în persoană sau pe un canal existent). Distribuie linkul de verificare după rezervarea înlocuirii. Nu se trimite automat niciun mesaj.",
    "keep_original": "Programarea inițială rămâne confirmată până accepți înlocuirea. Refuzul, o sugestie alternativă sau expirarea păstrează programarea inițială.",
    "deadline": "Înlocuirea este rezervată până la {{expiry}}.",
    "pending_status": "Se așteaptă decizia clientului. Programarea inițială este păstrată.",
    "accepted_status": "Înlocuirea a fost acceptată. Programarea confirmată a fost mutată la intervalul afișat.",
    "declined_status": "Înlocuirea a fost refuzată. Programarea inițială este păstrată.",
    "rescheduled_status": "S-a cerut o alternativă. Înlocuirea a fost eliberată; programarea inițială este păstrată.",
    "expired_status": "Înlocuirea a expirat. Programarea inițială este păstrată.",
    "propose": "Rezervă înlocuirea și înregistrează comunicarea",
    "link": "Link de verificare pentru client",
    "open": "Verifică reprogramarea",
    "accepted": "Acceptă înlocuirea",
    "declined": "Păstrează programarea inițială",
    "rescheduled": "Propune alt interval",
    "counter_help": "Sugestia nu rezervă un interval alternativ. Înlocuirea propusă va fi eliberată; programarea inițială rămâne confirmată.",
    "suggested": "Alternativa clientului: {{time}}",
    "unchanged_terms": "Servicii, prețuri și echipă neschimbate",
    "close_expired": "Închide oferta expirată",
    "expired_at": "Înlocuirea a expirat la {{expiry}}.",
    "superseded_status": "Oferta a fost înlocuită de o modificare a lucrării. Rezervarea alternativă a fost eliberată."
  },
  "calendar": {
    "title": "Calendar",
    "help": "Șapte zile calendaristice ale locației în {{zone}}. Programările păstrează fusul orar convenit.",
    "week_from": "Săptămână începând cu",
    "show": "Arată săptămâna",
    "navigation": "Navigare calendar",
    "previous": "Săptămâna anterioară",
    "today": "Astăzi",
    "next": "Săptămâna următoare",
    "empty": "Nicio programare sau rezervare activă în această săptămână.",
    "hold": "Interval propus / rezervat",
    "past": "Lucrare anterioară",
    "current": "Lucrare curentă",
    "future": "Lucrare viitoare",
    "occupied": "Boxă ocupată până la Gata de ridicare",
    "pages": "Pagini calendar",
    "page": "Pagina {{page}} din {{pages}}"
  },
  "booking": {
    "help": "Alege clientul și vehiculul, apoi programează lucrarea de detailing.",
    "discard_profile": "Renunți la detaliile nesalvate ale profilului?",
    "select_profiles": "Alege clientul și vehiculul înainte de a confirma lucrarea.",
    "saving": "Se salvează…",
    "summary": "Rezumatul programării",
    "draft_help": "Detaliile programării se păstrează în această ciornă cât timp adaugi sau schimbi profilurile.",
    "quick_customer": "Salvează clientul și revino la această programare.",
    "quick_vehicle": "Salvează vehiculul și revino la această programare.",
    "changed_terms": "Acest serviciu s-a modificat. Verifică prețul, durata și taxele curente înainte de a accepta noile condiții.",
    "previous_terms": "Selectat anterior",
    "accept_terms": "Acceptă noile condiții ale serviciului",
    "removed_services": "Nu mai sunt disponibile: {{names}}. Alege un înlocuitor sau confirmă eliminarea.",
    "confirm_removal": "Confirmă eliminarea serviciului"
  },
  "customer_workspace": {
    "search": "Caută după nume, e-mail sau telefon",
    "scope": "Lucrări la {{location}}",
    "no_jobs": "Nu există încă lucrări la această locație.",
    "no_requests": "Nu există încă solicitări la această locație."
  },
  "vehicle_workspace": {
    "service_history": "Istoricul serviciilor",
    "no_visits": "Nu există încă vizite înregistrate la această locație."
  },
  "integrations": {
    "title": "Integrări",
    "description": "Conectează conturile companiei tale. Disponibile în toate planurile; se pot aplica tarife și permisiuni ale furnizorului. Conectarea nu cumpără un abonament la furnizor.",
    "test": "Conexiuni de facturare de test",
    "default": "Facturi viitoare: {{provider}}",
    "default_help": "Configurarea reușită a altui furnizor de facturare schimbă facturile viitoare. Facturile existente își păstrează furnizorul. Erorile așteaptă reîncercarea și nu schimbă automat furnizorul.",
    "pending": "{{count}} solicitări de facturare necesită atenție sau așteaptă reîncercarea. Deschide facturile lucrării pentru verificare sau reîncercare.",
    "unavailable": "Configurarea conexiunii nu este încă disponibilă. Furnizorul actual de facturare rămâne selectat.",
    "updated": "Conexiune verificată.",
    "disconnected": "Conexiune deconectată. Furnizorul implicit rămâne neschimbat.",
    "series": "Serie de facturare existentă",
    "choose_series": "Alege o serie existentă",
    "save_series": "Verifică și folosește seria",
    "guide": "Ghid {{provider}}",
    "connect": "Conectează {{provider}}",
    "disconnect": "Deconectează {{provider}}",
    "categories": {
      "payment_invoice": "Plăți și facturare",
      "invoice": "Facturare",
      "reporting": "Raportare fiscală",
      "messaging": "Mesagerie"
    },
    "states": {
      "ready": "Conectat și verificat",
      "series": "Alege o serie existentă pentru a finaliza configurarea",
      "unverified": "Așteaptă verificarea",
      "unavailable": "Verificare indisponibilă",
      "disconnected": "Neconectat"
    },
    "help": {
      "stripe": "Furnizorul inițial de facturare. Încasările și disponibilitatea facturării sunt verificate separat de abonamentul GarageClerk.",
      "smartbill": "Folosește contul tău SmartBill cu acces API și serii de facturare existente.",
      "easybill_ro": "Folosește contul tău românesc EasyBill.ro. Accesul trebuie verificat.",
      "ro_efactura": "Raportează aceeași factură Stripe cu autorizarea companiei. Nu înlocuiește furnizorul de facturare și nu emite altă factură.",
      "facebook": "Conectează pagina Facebook a companiei când autorizarea pentru mesagerie este disponibilă.",
      "instagram": "Conectează contul profesional al companiei când autorizarea pentru mesagerie este disponibilă.",
      "whatsapp": "Conectează contul WhatsApp Business al companiei când autorizarea pentru mesagerie este disponibilă."
    },
    "access_token": "Token de acces la furnizor",
    "changed": "Conexiunea s-a schimbat în timpul verificării. Verifică setările curente și încearcă din nou.",
    "dispatch": {
      "queued": "Solicitare de facturare în așteptare. Se folosește furnizorul selectat, fără înlocuire automată.",
      "running": "Solicitare de facturare în curs. Un rezultat incert este verificat înainte de reîncercare.",
      "waiting": "Solicitarea așteaptă reîncercarea cu furnizorul original. Verifică conexiunea sau confirmă din nou pentru reîncercare.",
      "attention": "Solicitarea necesită atenție. Verifică datele de facturare și conexiunea, apoi confirmă din nou pentru reîncercare."
    },
    "verified_on": "Ultima verificare: {{date}}",
    "setup_unavailable": "Configurarea conexiunii nu este încă disponibilă."
  }
}
